var _style, _defs, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 768 450",
    style: {
      enableBackground: "new 0 0 768 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000137131954332907819460000011453997761727916209_);}\r\n\t.st1{fill:url(#Trazado_77_00000028292257180629363020000004456166468366447280_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_78_00000036936193654515988320000007497018993352892293_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_79_00000183929867923233614210000005833587468940733610_);}\r\n\t.st4{fill:url(#Trazado_80_00000110462108328455233540000003692516231501475974_);}\r\n\t.st5{fill:url(#Trazado_81_00000027593297678971641850000010184510787386125464_);}\r\n\t.st6{fill:url(#Trazado_82_00000065041576860706627000000010502308844069848712_);}\r\n\t.st7{fill:url(#Trazado_83_00000083805527981447187960000006447393820437002900_);}\r\n\t.st8{fill:url(#Trazado_84_00000149344721074445062280000008649514279288416649_);}\r\n\t.st9{fill:url(#Trazado_85_00000183966242900618199830000010517564152164589487_);}\r\n\t.st10{fill:url(#Trazado_86_00000033364111989975779770000002833597035336187789_);}\r\n\t.st11{fill:url(#Trazado_87_00000020373875005469077270000007778594514992778374_);}\r\n\t.st12{fill:url(#Trazado_88_00000071533774792996686740000001619889077883563415_);}\r\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_89_00000119796084223474508180000014047694789897715871_);}\r\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_90_00000042709107652774051980000000763235953122991502_);}\r\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_91_00000045576987610693217770000016617141712425877653_);}\r\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_92_00000114786889326511405070000003011531345029531784_);}\r\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_93_00000166660195201712518030000003263186058917992358_);}\r\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_94_00000151523835600442127020000001587035027664145331_);}\r\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_95_00000096029120775790000820000009177273018763488669_);}\r\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_96_00000093168705947281217560000009656221394922515854_);}\r\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_97_00000125577962480232345490000010785961365288345218_);}\r\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_98_00000156570199936593864280000006419321164259393982_);}\r\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_99_00000163777340882383231470000006214566049279327417_);}\r\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_100_00000067209805502074805110000009813087742654523812_);}\r\n\t.st25{fill:url(#Trazado_101_00000087389269202625949860000008420227104071397811_);}\r\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_102_00000174563323787995384260000000290351326961387958_);}\r\n\t.st27{fill:url(#Trazado_103_00000117638229770663568200000016096220501414875027_);}\r\n\t.st28{fill:url(#Trazado_104_00000165922642502475491350000013232259352696624805_);}\r\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_105_00000004518881554115590230000012385303400723077518_);}\r\n\t.st30{fill:url(#Trazado_106_00000056402364228189831320000014288819878284136354_);}\r\n\t.st31{fill:url(#Trazado_107_00000128451171673486214100000010685768829343699383_);}\r\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_108_00000122713402615451166010000008808655272782752932_);}\r\n\t.st33{fill:url(#Trazado_109_00000134929609972264600220000005304446719766331839_);}\r\n\t.st34{fill:url(#Trazado_110_00000038413766389369954990000009221540339962115999_);}\r\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_111_00000031169734985652095740000000755961953781430195_);}\r\n\t.st36{fill:url(#Trazado_112_00000054945913419608685080000004878296236545843125_);}\r\n\t.st37{fill:url(#Trazado_113_00000020382830859772171250000015193907367850440127_);}\r\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_114_00000117650142168268607700000017267792465370749322_);}\r\n\t.st39{fill:url(#Trazado_115_00000168095501086946715640000003888056393434512300_);}\r\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_116_00000000193837224537157210000015032703859985102513_);}\r\n\t.st41{fill:url(#Trazado_117_00000041260453660412699630000000193905131506539911_);}\r\n\t.st42{fill:url(#Trazado_118_00000108281225870963463270000016175157640534931123_);}\r\n\t.st43{fill:url(#Trazado_119_00000078729824211847566060000010597600378709394314_);}\r\n\t.st44{fill:url(#Trazado_120_00000114040983756214091850000017397513944445622186_);}\r\n\t.st45{fill:url(#Trazado_121_00000160192630000834673640000017482583761045312642_);}\r\n\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_122_00000067230458723916010770000008334068026007001521_);}\r\n\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_123_00000144331019310099226480000001319921666152484781_);}\r\n\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_124_00000009556985469124831400000016171249503149527172_);}\r\n\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_125_00000120544758576292228960000009562884189215363202_);}\r\n\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_126_00000065041844065472103550000003140825710063365504_);}\r\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_127_00000167383653031154708760000006176203107145897360_);}\r\n\t.st52{fill:url(#Trazado_128_00000008847935795501534130000005699787275513802160_);}\r\n\t.st53{fill:url(#Trazado_129_00000084526300830249101630000006754988336329536927_);}\r\n\t.st54{fill:url(#Trazado_130_00000175304476519853163170000011851799593656415135_);}\r\n\t.st55{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_131_00000019663284460154341450000013874375473829711034_);}\r\n\t.st56{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_132_00000032632243446408683260000008523260695579228065_);}\r\n\t.st57{fill:url(#Trazado_133_00000142875280329853236970000018374499670541366665_);}\r\n\t.st58{fill:url(#Trazado_134_00000093139477225659864680000014213002383548300475_);}\r\n\t.st59{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_135_00000035507495911986116870000001131463813332127677_);}\r\n\t.st60{fill:url(#Trazado_136_00000149370073371462265130000010723918090768394890_);}\r\n\t.st61{fill:url(#Trazado_137_00000116943975534438692590000007873612800761880976_);}\r\n\t.st62{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_138_00000060713293169790858960000015545923927613136808_);}\r\n\t.st63{fill:url(#Trazado_139_00000162313608480737904170000016944796618165697682_);}\r\n\t.st64{fill:url(#Trazado_140_00000102529315773579225660000014389574623535420800_);}\r\n\t.st65{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_141_00000150083693865778242220000004442593049857683132_);}\r\n\t.st66{fill:url(#Trazado_142_00000078010114291686326780000007598017994503233972_);}\r\n\t.st67{fill:url(#Trazado_143_00000039824172292497699070000005401413817160452000_);}\r\n\t.st68{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_144_00000066485849555565045620000015543082864115800708_);}\r\n\t.st69{fill:url(#Trazado_145_00000029758207452293430360000006655262150402313660_);}\r\n\t.st70{fill:url(#Trazado_146_00000067210424408065543830000013535776323958667663_);}\r\n\t.st71{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_147_00000168094800278247487300000009698524032415169463_);}\r\n\t.st72{fill:url(#Trazado_148_00000181808058964938462330000002678085677548434064_);}\r\n\t.st73{fill:url(#Trazado_149_00000044164057152877924800000016829524195332123568_);}\r\n\t.st74{fill:none;stroke:#724F2B;stroke-width:0.93;stroke-miterlimit:10;}\r\n\t.st75{enable-background:new    ;}\r\n\t.st76{fill:#D1BFAF;}\r\n\t.st77{fill:#605B55;}\r\n\t.st78{fill:#89786B;}\r\n\t.st79{fill:none;stroke:#D1BFAF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: -0.3,
    width: 768,
    height: 1054.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140004238546316341560000006627277768263167659_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "header",
    style: {
      clipPath: "url(#SVGID_00000140004238546316341560000006627277768263167659_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_77_00000158717217265556772050000014053061563293274814_",
    gradientUnits: "userSpaceOnUse",
    x1: -957.0262,
    y1: -1412.8298,
    x2: -956.0322,
    y2: -1412.8298,
    gradientTransform: "matrix(999.1893 0 0 489.0864 956056.6875 691061.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8EAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#F5DFC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDC797"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77",
    style: {
      fill: "url(#Trazado_77_00000158717217265556772050000014053061563293274814_)"
    },
    d: "M131.6,255.8 c27.4-39.3,32.6-94.5,46.1-143.8S217.6,15.5,269,9.2C320.7,2.9,381.1,39.1,438.2,62C556.1,109.5,676.5,99.9,752,37.1 c28.1-23.3,50.7-61.7,31-106.5c-14-32-46.5-57.5-77.8-69.7s-62-13.6-91.9-14.8c-195-8-390-16-584.9-24 c-66.5-2.7-136.6-4.5-182.7,30.5c-41.8,31.7-57.9,90.6-53.8,153.2c2.8,43.2,16.4,86.7,28.1,131c7.1,26.8,11.3,55.8,25.2,82.5 c35.6,68,133,94.2,186.2,90.3C73.6,306.4,109.6,287.4,131.6,255.8L131.6,255.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_78_00000117662137375232150890000016511929728950653092_",
    gradientUnits: "userSpaceOnUse",
    x1: -951.5239,
    y1: -1407.8511,
    x2: -952.7238,
    y2: -1409.246,
    gradientTransform: "matrix(187.5223 0 0 180.3948 179293 254317.0625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_78_00000117662137375232150890000016511929728950653092_)"
    },
    d: " M604.6,255c3.4-11.1,11.8-20.4,22.8-28.6c11-8.1,24.7-15.1,39-21.7c13.8-6.3,28.1-12.3,41.1-18.3c15.6-7.3,29.7-21,41.9-37 c17.6-23.1,31.4-51.1,39-72.9c0.4-0.9,1.4-1.3,2.3-1c0.9,0.3,1.5,1.2,1.2,2.2l0,0c-7.9,22-21.7,50.4-39.8,73.5 c-12.7,16.3-27.6,29.9-43.6,37c-11.2,5-23.5,9.9-35.5,15.2c-12.1,5.2-23.9,10.8-34.3,17c-16,9.6-28.6,20.8-33,35 c-0.1,0.3-0.5,0.5-0.8,0.4C604.7,255.6,604.5,255.3,604.6,255L604.6,255L604.6,255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_79_00000169552976258401828490000010701706081901758623_",
    gradientUnits: "userSpaceOnUse",
    x1: -891.2573,
    y1: -1332.4417,
    x2: -904.6263,
    y2: -1348.3657,
    gradientTransform: "matrix(16.8248 0 0 15.8033 15753.5059 21493.1465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_79_00000169552976258401828490000010701706081901758623_)"
    },
    d: " M605.2,255.1c0.7,1.3,4.9,8.1,4.9,14.7c0,4.4-18.4-5.1-16.7-11C593.9,257,600.3,255.9,605.2,255.1L605.2,255.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_80_00000126296228978351363350000017883360416372912828_",
    gradientUnits: "userSpaceOnUse",
    x1: -897.2972,
    y1: -1339.7036,
    x2: -909.4493,
    y2: -1354.2275,
    gradientTransform: "matrix(18.5131 0 0 17.3242 17369.9844 23645.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    style: {
      fill: "url(#Trazado_80_00000126296228978351363350000017883360416372912828_)"
    },
    d: "M606,254.8 l0.2,0.4c1.2,2.1,4.8,8.4,4.8,14.7c0,0.8-0.4,1.4-1.2,1.7c-2.5,0.9-8.8-2-12.8-5.2c-3.5-2.8-5-5.5-4.4-7.7 c0.6-2.1,5.8-3.1,12.4-4.2c0.2,0,0.3,0,0.4,0C605.7,254.5,605.9,254.7,606,254.8L606,254.8z M609.1,270.1 c0.1,0,0.2-0.1,0.2-0.3c0-3.9-1.5-8.5-4.5-13.8c-3.7,0.6-10.2,1.7-10.6,3.1c-0.4,1.5,1,3.8,3.9,6.1c2.4,1.9,5.1,3.5,8.1,4.5 C607.1,270.1,608.1,270.3,609.1,270.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_81_00000142155214650216604540000013242104688644248745_",
    gradientUnits: "userSpaceOnUse",
    x1: -941.028,
    y1: -1357.7579,
    x2: -944.2729,
    y2: -1368.528,
    gradientTransform: "matrix(69.306 0 0 23.3568 65988.3203 32139.166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81",
    style: {
      fill: "url(#Trazado_81_00000142155214650216604540000013242104688644248745_)"
    },
    d: "M620.4,225.5 c0.1,0.4-0.1,0.9-0.5,1.1c-0.1,0.1-0.3,0.2-0.5,0.3c-11.5,7.3-23.6,4.7-31.8,1.1c-11.5-4.9-23.5-8.5-35.7-10.7 c-0.3,0-0.6-0.3-0.7-0.6c-0.1-0.3,0-0.6,0.3-0.8c0.2-0.1,21.4-12.7,43.8-5.4c0.3,0.1,0.7,0.2,1,0.3 C611.2,216,620,223.2,620.4,225.5L620.4,225.5z M588.3,226.7c7.7,3.4,19.2,5.9,30.1-1l0.3-0.2c-0.8-1.7-8.6-8.5-23.9-13.5 c-17.9-5.9-35,1.4-40.5,4.2C566,218.5,577.4,222,588.3,226.7L588.3,226.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_82_00000168817290312354852100000002887891710064746677_",
    gradientUnits: "userSpaceOnUse",
    x1: -914.259,
    y1: -1391.5662,
    x2: -923.0991,
    y2: -1396.1461,
    gradientTransform: "matrix(25.447 0 0 54.9394 24068.2676 76849.5703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82",
    style: {
      fill: "url(#Trazado_82_00000168817290312354852100000002887891710064746677_)"
    },
    d: "M666.9,208.9 c0.1,0.1,11.5,10.1,4,28.2c-7.3,17.8-18.9,26-19.4,26.4c-0.3,0.2-0.6,0.2-0.9,0.1c-0.3-0.1-0.5-0.4-0.5-0.7 c0-0.1-1.3-14.1-2.1-28.7c-0.7-12.2,4.7-19.8,17.9-25.5C666.3,208.6,666.7,208.7,666.9,208.9L666.9,208.9z M669.4,236.5 c6.3-15.3-1.2-24.2-3.1-26.1c-12.3,5.4-17.1,12.4-16.5,23.9c0.6,11.7,1.6,23,2,27C659.5,254.5,665.5,246.1,669.4,236.5 L669.4,236.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_83_00000173842735960820528760000009162132998700259737_",
    gradientUnits: "userSpaceOnUse",
    x1: -941.1797,
    y1: -1364.8777,
    x2: -944.4437,
    y2: -1374.4777,
    gradientTransform: "matrix(68.9099 0 0 26.212 65716.0938 36125.4609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    style: {
      fill: "url(#Trazado_83_00000173842735960820528760000009162132998700259737_)"
    },
    d: "M727.1,171.5 c0.5,1.1,0,1.5-0.3,1.7l0,0c-1.7,0.9-26,9.5-41.8,3.4c-15.4-6-26-22.2-26.5-22.9c-0.2-0.3-0.2-0.7,0.1-0.9s0.7-0.3,1-0.1 c0.1,0,8.3,4.8,29.8,2.1c5.7-0.7,11.5-0.1,17,1.8C718.2,160.5,726,169,727.1,171.5L727.1,171.5z M685.6,175.1 c14.3,5.5,36.7-1.7,40-3.1c-0.5-1.1-3.1-4.4-7.7-7.8c-5-3.7-15.3-9.6-28.1-8c-15.5,2-24.3,0.2-28.3-1.2 C664.9,159.7,674,170.6,685.6,175.1L685.6,175.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_84_00000005950210652998435070000015708352625991627704_",
    gradientUnits: "userSpaceOnUse",
    x1: -913.7148,
    y1: -1393.0321,
    x2: -922.7758,
    y2: -1397.3831,
    gradientTransform: "matrix(24.8475 0 0 57.8371 23571.5781 80911.2031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_84",
    style: {
      fill: "url(#Trazado_84_00000005950210652998435070000015708352625991627704_)"
    },
    d: "M750.5,182.3 c-0.3,7.1-4.1,12.6-7.9,17.9c-2.1,2.8-3.9,5.8-5.5,8.9c-1.7,3.3-2.9,6.8-3.4,10.5c-0.2,1.5-0.2,2.9-0.1,4.4v0.1 c0.2,1,0.3,1.7-0.4,2c-0.2,0.1-0.5,0.1-0.7,0c-0.3-0.1-0.5-0.2-1.1-2.1c-0.4-1.2-0.8-2.3-1.2-3.4c-2.2-5.4-3.6-11.2-4.3-17 c-0.6-5.3-0.1-10.6,1.4-15.7c1.6-5.1,3.3-10.4,14.6-19.4c0.2-0.2,0.5-0.2,0.8-0.1C748.1,170.1,750.7,177.6,750.5,182.3 L750.5,182.3z M732,219.2c0.6-3.8,1.8-7.5,3.5-10.9c1.6-3.2,3.5-6.2,5.6-9.1c3.8-5.4,7.3-10.4,7.6-17.1 c0.2-4-1.9-10.5-6.2-12.3c-10.6,8.5-12.2,13.5-13.7,18.4c-1.4,4.9-1.9,10.1-1.3,15.2c0.7,5.7,2.1,11.3,4.2,16.6 c0,0.1,0.1,0.2,0.1,0.3C731.9,220,732,219.6,732,219.2L732,219.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_85_00000041259743446334622090000007689708634315686843_",
    gradientUnits: "userSpaceOnUse",
    x1: -938.6549,
    y1: -1311.259,
    x2: -942.3859,
    y2: -1330.879,
    gradientTransform: "matrix(60.2831 0 0 12.833 57361.3516 17248.1738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85",
    style: {
      fill: "url(#Trazado_85_00000041259743446334622090000007689708634315686843_)"
    },
    d: "M627.9,226.5 c-0.1,0-0.1,0-0.2,0c-19-1.9-26.7-4.3-33.5-6.4c-6.2-1.9-12-3.8-25.1-4.9c-0.4-0.1-0.8,0.2-0.9,0.6l0,0c0,0.4,0.4,0.8,0.8,0.8 c12.9,1.1,18.4,2.8,24.7,4.8c6.9,2.2,14.7,4.6,33.9,6.5c0.4,0.1,0.8-0.2,0.9-0.6l0,0C628.4,226.9,628.2,226.6,627.9,226.5 L627.9,226.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_86_00000018934060337210881620000006987565087587975818_",
    gradientUnits: "userSpaceOnUse",
    x1: -868.0772,
    y1: -1386.8199,
    x2: -886.2502,
    y2: -1392.3099,
    gradientTransform: "matrix(12.3573 0 0 45.8475 11535.333 63975.4141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86",
    style: {
      fill: "url(#Trazado_86_00000018934060337210881620000006987565087587975818_)"
    },
    d: "M666.8,205.5 L666.8,205.5c-0.4-0.2-0.9,0-1.1,0.4c-2.4,6.5-3.9,13.4-4.5,20.3c-0.7,6.1-1.3,11.9-6.2,24c-0.1,0.4,0.1,0.9,0.5,1l0,0 c0.4,0.2,0.9,0,1.1-0.4c5-12.3,5.6-18.2,6.3-24.4c0.6-6.8,2.1-13.5,4.4-20C667.5,206,667.2,205.6,666.8,205.5L666.8,205.5 L666.8,205.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_87_00000075128955617292129730000011326395925988560051_",
    gradientUnits: "userSpaceOnUse",
    x1: -860.6741,
    y1: -1386.3531,
    x2: -880.5511,
    y2: -1391.9801,
    gradientTransform: "matrix(11.3101 0 0 44.7204 10608.5674 62334.9883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_87",
    style: {
      fill: "url(#Trazado_87_00000075128955617292129730000011326395925988560051_)"
    },
    d: "M741.9,160.7 c-0.1,0-0.3-0.1-0.4,0c-0.4,0-0.7,0.4-0.7,0.8v0.1c1.3,5.7-1.3,26.7-9.3,42.7c-0.2,0.4,0,0.8,0.4,1l0,0 c0.4,0.2,0.9,0.1,1.1-0.3c8.1-16.3,10.7-37.8,9.4-43.6C742.4,161,742.2,160.8,741.9,160.7L741.9,160.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_88_00000086675690282184474330000016267775733646448267_",
    gradientUnits: "userSpaceOnUse",
    x1: -937.6648,
    y1: -1308.5299,
    x2: -941.6549,
    y2: -1328.9729,
    gradientTransform: "matrix(56.3773 0 0 12.3177 53725.9414 16464.7949)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_88",
    style: {
      fill: "url(#Trazado_88_00000086675690282184474330000016267775733646448267_)"
    },
    d: "M730.3,172 c-0.1,0-0.2-0.1-0.3-0.1c-25.8-0.1-41.4-5.2-54.3-10.7c-0.4-0.2-0.9,0-1.1,0.4c-0.2,0.4,0,0.9,0.4,1l0,0 c13.2,5.6,28.9,10.7,55.1,10.8c0.4,0,0.8-0.3,0.8-0.7c0,0,0,0,0-0.1C730.8,172.4,730.6,172.1,730.3,172L730.3,172z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_89_00000057145233664392889250000002455470826230009263_",
    gradientUnits: "userSpaceOnUse",
    x1: -824.3632,
    y1: -1283.0962,
    x2: -850.788,
    y2: -1308.0311,
    gradientTransform: "matrix(8.5116 0 0 10.088 7793.2275 13364.1807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_89",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_89_00000057145233664392889250000002455470826230009263_)"
    },
    d: " M597.2,227.1c0.9-0.3,1.8-0.6,2.7-0.9c0.9-0.3,1.7-0.7,2.5-1.2c0.4-0.2,0.7-0.4,1-0.7c0.2-0.2,0.4-0.4,0.5-0.7s0.1-0.7,0-1 c-0.1-0.4-0.3-0.8-0.4-1.2c-0.1-0.3-0.3-0.6-0.4-0.9c-0.2-0.3-0.3-0.6-0.5-0.8c-0.3-0.4-0.5-0.7-0.8-1c-0.5-0.5-0.9-1-1.4-1.5 v-0.1l0,0h0.1l0,0c0.6,0.4,1.2,0.8,1.8,1.2c0.4,0.3,0.8,0.6,1.1,0.9c0.3,0.3,0.5,0.5,0.8,0.8c0.2,0.3,0.5,0.6,0.7,0.9 c0.4,0.5,0.7,1.1,0.9,1.7c0.1,0.5,0.1,1,0,1.5s-0.4,0.9-0.8,1.2c-0.5,0.4-1.1,0.7-1.7,0.9c-0.9,0.3-1.9,0.6-2.9,0.7 c-1,0.2-2,0.2-3,0.3C597.2,227.2,597.1,227.2,597.2,227.1C597.1,227.1,597.1,227.1,597.2,227.1L597.2,227.1L597.2,227.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_90_00000006675392465227900260000004299119139523418242_",
    gradientUnits: "userSpaceOnUse",
    x1: -796.2764,
    y1: -1272.3745,
    x2: -828.0734,
    y2: -1299.1775,
    gradientTransform: "matrix(7.0725 0 0 9.3815 6404.1636 12360.4482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_90",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_90_00000006675392465227900260000004299119139523418242_)"
    },
    d: " M586.7,222.9c0.4-0.2,0.7-0.3,1.1-0.6c0.5-0.3,1-0.7,1.5-1c0.6-0.4,1.1-0.8,1.7-1.3c0.3-0.3,0.6-0.6,0.8-0.9 c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.3,0.2-0.7,0.1-1c0-0.2-0.1-0.3-0.1-0.5s-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.3-0.5-0.5-0.7-0.7c-0.4-0.4-0.9-0.7-1.3-1v-0.1l0,0h0.1c0.5,0.2,1.1,0.4,1.6,0.7 c0.4,0.2,0.7,0.4,1,0.6c0.2,0.2,0.4,0.3,0.6,0.5c0.2,0.2,0.3,0.4,0.5,0.6c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.4,0.3,0.6 c0.2,0.6,0.2,1.2,0.1,1.7c-0.1,0.4-0.3,0.7-0.5,1c-0.3,0.4-0.8,0.8-1.2,1.1c-0.7,0.4-1.4,0.7-2.1,1c-0.6,0.2-1.2,0.4-1.8,0.6 c-0.4,0.1-0.8,0.2-1.3,0.2C586.8,223,586.7,223,586.7,222.9L586.7,222.9C586.7,222.8,586.7,222.8,586.7,222.9L586.7,222.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_91_00000097490135788856223820000003254792692421866922_",
    gradientUnits: "userSpaceOnUse",
    x1: -794.5156,
    y1: -1225.6614,
    x2: -826.4946,
    y2: -1261.1073,
    gradientTransform: "matrix(7.0323 0 0 7.1041 6354.6899 9135.5674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_91",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_91_00000097490135788856223820000003254792692421866922_)"
    },
    d: " M575.7,219.7c0.8-0.4,1.6-0.8,2.4-1.3c0.3-0.2,0.6-0.4,0.9-0.5c0.4-0.3,0.9-0.5,1.3-0.8c0.2-0.1,0.4-0.3,0.5-0.5 c0.1-0.1,0.2-0.3,0.2-0.4c0-0.5-0.2-0.9-0.5-1.2c-0.2-0.2-0.3-0.3-0.5-0.5s-0.4-0.3-0.6-0.4c-0.3-0.2-0.5-0.3-0.8-0.5 c-0.4-0.2-0.8-0.5-1.2-0.7c0,0-0.1,0,0-0.1l0,0c0,0,0.1-0.1,0.1,0c0.4,0.1,0.8,0.2,1.2,0.3s0.8,0.2,1.2,0.4 c0.3,0.1,0.5,0.2,0.8,0.3s0.5,0.3,0.7,0.4c0.8,0.4,1.3,1.2,1.4,2.1c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.6,0.6-1,0.7 c-0.7,0.3-1.4,0.6-2.1,0.9c-1.1,0.3-2.2,0.5-3.4,0.7C575.8,219.8,575.7,219.8,575.7,219.7C575.7,219.8,575.7,219.7,575.7,219.7 L575.7,219.7L575.7,219.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_92_00000117636175199401575610000013786737986809780874_",
    gradientUnits: "userSpaceOnUse",
    x1: -856.7852,
    y1: -1267.3831,
    x2: -877.369,
    y2: -1296.16,
    gradientTransform: "matrix(10.9301 0 0 8.7482 10165.2949 11487.2393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_92",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_92_00000117636175199401575610000013786737986809780874_)"
    },
    d: " M662.9,245.6c0.1-0.3,0-0.5,0-0.8c-0.1-0.4-0.3-0.9-0.4-1.2c-0.2-0.5-0.4-1.1-0.6-1.6c-0.2-0.5-0.5-1-0.8-1.5 c-0.3-0.4-0.6-0.9-1-1.2c-0.3-0.4-0.8-0.6-1.2-0.8c-1-0.5-2.2-0.5-3.2-0.1c-1.1,0.4-2.2,1-3,1.9h-0.1v-0.1l0,0 c0.6-0.9,1.3-1.6,2.1-2.3c0.4-0.3,0.8-0.5,1.3-0.7c1.1-0.4,2.4-0.4,3.5-0.1c0.6,0.2,1.1,0.5,1.6,0.9c0.4,0.4,0.8,0.8,1.1,1.3 s0.6,1.1,0.8,1.7c0.3,0.8,0.4,1.7,0.5,2.5c0,0.3,0.1,0.8,0.1,1.2c0,0.3-0.1,0.6-0.2,0.8C663,245.7,663,245.7,662.9,245.6 L662.9,245.6L662.9,245.6L662.9,245.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_93_00000090993068874634489490000015784964246826022064_",
    gradientUnits: "userSpaceOnUse",
    x1: -874.8994,
    y1: -1264.17,
    x2: -891.7224,
    y2: -1293.4481,
    gradientTransform: "matrix(13.3704 0 0 8.5946 12503.3145 11260.5967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_93",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_93_00000090993068874634489490000015784964246826022064_)"
    },
    d: " M665.7,236.2c-0.1-0.4-0.2-0.8-0.3-1.2c-0.2-0.6-0.5-1.2-0.8-1.7c-0.2-0.4-0.5-0.8-0.8-1.2s-0.6-0.8-0.9-1.2 c-0.4-0.5-1-1-1.6-1.2c-0.4-0.2-0.9-0.3-1.3-0.4c-0.6-0.1-1.2-0.2-1.8-0.1c-0.6,0-1.2,0.1-1.8,0.4c-0.5,0.2-1,0.4-1.5,0.7 c-0.7,0.5-1.4,1-2.1,1.5h-0.1v-0.1l0,0c0.6-0.7,1.1-1.3,1.7-2c0.4-0.4,0.9-0.8,1.5-1.1c0.8-0.4,1.6-0.7,2.5-0.8 c0.6-0.1,1.3-0.1,1.9,0c0.6,0.1,1.3,0.3,1.8,0.6c0.9,0.4,1.6,1.1,2.1,1.9c0.3,0.4,0.5,0.9,0.8,1.4c0.2,0.5,0.4,1,0.5,1.5 c0.2,0.6,0.3,1.2,0.4,1.9c0.1,0.4,0.1,0.9,0,1.3C665.8,236.2,665.8,236.3,665.7,236.2C665.8,236.2,665.8,236.2,665.7,236.2 L665.7,236.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_94_00000127044206775921024500000006828582121741138611_",
    gradientUnits: "userSpaceOnUse",
    x1: -870.9076,
    y1: -1217.7515,
    x2: -888.4917,
    y2: -1255.8905,
    gradientTransform: "matrix(12.7917 0 0 6.5966 11951.1904 8423.9424)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_94",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_94_00000127044206775921024500000006828582121741138611_)"
    },
    d: " M667.3,226.1c-0.1-0.3-0.3-0.6-0.5-0.9c-0.3-0.4-0.6-0.9-0.9-1.3c-0.3-0.5-0.7-0.9-1.1-1.3c-0.4-0.4-0.8-0.7-1.3-1 c-0.3-0.2-0.6-0.3-1-0.4c-0.3-0.1-0.7-0.2-1.1-0.2c-0.8-0.1-1.5,0-2.3,0.1c-1.6,0.3-3.1,0.9-4.4,1.8h-0.1v-0.1l0,0 c0.6-0.7,1.4-1.4,2.2-1.9c0.9-0.6,1.9-1,2.9-1.2c0.8-0.2,1.5-0.2,2.3-0.1c0.8,0.1,1.6,0.4,2.2,0.9c0.4,0.3,0.8,0.7,1.2,1.1 c0.5,0.6,0.8,1.2,1.1,1.9c0.2,0.4,0.3,0.8,0.5,1.2C667.1,225.1,667.2,225.5,667.3,226.1C667.5,226.1,667.5,226.1,667.3,226.1 C667.4,226.1,667.4,226.1,667.3,226.1C667.4,226.1,667.4,226.1,667.3,226.1L667.3,226.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_95_00000114761875370776801420000002271644591145964935_",
    gradientUnits: "userSpaceOnUse",
    x1: -847.8877,
    y1: -1265.0156,
    x2: -870.0506,
    y2: -1293.8766,
    gradientTransform: "matrix(10.15 0 0 8.7155 9469.8584 11370.8174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_95_00000114761875370776801420000002271644591145964935_)"
    },
    d: " M704.2,175.4c0.6-0.3,1.2-0.5,1.8-0.8c0.9-0.4,1.8-0.8,2.7-1.3c0.6-0.3,1.2-0.6,1.7-0.9c0.4-0.2,0.7-0.4,1.1-0.6 c0.2-0.1,0.5-0.3,0.7-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.3,0.4-0.9,0.1-1.3c-0.4-0.6-0.9-1.1-1.5-1.5c-0.3-0.2-0.7-0.5-1-0.7 s-0.7-0.4-1.1-0.7c0,0-0.1-0.1,0-0.1l0,0h0.1l0,0c0.4,0.1,0.8,0.3,1.2,0.4s0.8,0.3,1.2,0.5c0.7,0.3,1.3,0.7,1.8,1.2 c0.2,0.2,0.5,0.5,0.6,0.8c0.4,0.7,0.4,1.6-0.1,2.3c-0.1,0.2-0.3,0.4-0.5,0.5c-0.3,0.2-0.5,0.4-0.8,0.6 c-0.4,0.2-0.8,0.4-1.2,0.6c-0.6,0.3-1.3,0.5-2,0.7c-0.8,0.2-1.7,0.4-2.5,0.6s-1.7,0.3-2.6,0.5 C704.2,175.5,704.2,175.5,704.2,175.4C704.1,175.5,704.1,175.4,704.2,175.4L704.2,175.4L704.2,175.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_96_00000181806211980881769380000001026477455986643105_",
    gradientUnits: "userSpaceOnUse",
    x1: -866.5681,
    y1: -1308.621,
    x2: -884.8441,
    y2: -1328.9979,
    gradientTransform: "matrix(12.3113 0 0 12.3547 11528.4521 16516.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_96",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_96_00000181806211980881769380000001026477455986643105_)"
    },
    d: " M692.3,173.1c1.7-0.3,3.4-0.8,4.9-1.4c0.7-0.3,1.5-0.7,2.2-1.1c0.7-0.4,1.3-0.9,1.9-1.4c0.3-0.3,0.6-0.6,0.9-1 c0.4-0.5,0.7-1.1,1-1.7c0.4-1.1,0.3-2.3-0.2-3.3c-0.2-0.4-0.4-0.8-0.7-1.1c-0.3-0.4-0.6-0.7-1-1V161l0,0h0.1 c0.4,0.3,0.8,0.6,1.2,0.9c0.4,0.3,0.7,0.7,1,1.1c0.8,1.1,1.1,2.5,0.9,3.9c-0.1,0.8-0.5,1.6-0.9,2.2c-0.3,0.5-0.7,0.9-1.1,1.2 c-0.7,0.6-1.4,1.1-2.2,1.5s-1.7,0.7-2.5,0.9c-1.8,0.4-3.6,0.6-5.4,0.6C692.3,173.2,692.3,173.2,692.3,173.1 C692.2,173.1,692.3,173.1,692.3,173.1L692.3,173.1L692.3,173.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_97_00000006688116260164515410000016312122998531764155_",
    gradientUnits: "userSpaceOnUse",
    x1: -844.2958,
    y1: -1257.8413,
    x2: -866.9097,
    y2: -1287.7853,
    gradientTransform: "matrix(9.9435 0 0 8.4126 9248.5908 10936.4551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_97_00000006688116260164515410000016312122998531764155_)"
    },
    d: " M680.8,169.2c0.3,0,0.6,0,0.9,0c0.7-0.2,1.4-0.4,2.1-0.7c0.9-0.3,1.7-0.6,2.5-1c0.4-0.2,0.8-0.4,1.1-0.6c0.3-0.2,0.7-0.4,1-0.7 c0.8-0.6,1.1-1.7,0.7-2.6c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.5-0.5c-0.3-0.3-0.6-0.5-1-0.7 v-0.1h0.1l0,0c0.4,0.1,0.8,0.3,1.1,0.5c0.3,0.1,0.5,0.3,0.7,0.5s0.4,0.4,0.6,0.6c0.2,0.2,0.4,0.4,0.5,0.7 c0.5,0.7,0.7,1.6,0.5,2.5c-0.1,0.6-0.4,1.1-0.8,1.5c-0.2,0.2-0.5,0.5-0.8,0.7c-0.4,0.3-0.8,0.5-1.3,0.7 c-0.6,0.2-1.1,0.4-1.7,0.5c-0.6,0.1-1.2,0.2-1.8,0.3c-0.5,0-1.3,0.2-2,0.2c-0.5,0-0.9-0.1-1.4-0.2c0,0-0.1,0,0-0.1 C680.8,169.2,680.8,169.2,680.8,169.2L680.8,169.2L680.8,169.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_98_00000018927585947780294230000017286974949441535882_",
    gradientUnits: "userSpaceOnUse",
    x1: -854.4562,
    y1: -1165.1273,
    x2: -875.7521,
    y2: -1214.2194,
    gradientTransform: "matrix(10.5652 0 0 5.1226 9892.71 6312.8481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_98_00000018927585947780294230000017286974949441535882_)"
    },
    d: " M729.3,200.1c0.1-0.4,0.3-0.7,0.6-1c0.4-0.4,0.8-0.8,1.1-1.2c0.4-0.4,0.7-0.8,1.2-1.2c0.3-0.2,0.6-0.5,0.9-0.7 c0.3-0.2,0.7-0.4,1.1-0.5c0.6-0.2,1.2-0.4,1.8-0.5c0.4-0.1,0.9,0,1.3,0c1,0.2,1.9,0.7,2.5,1.5v0.1l0,0h-0.1 c-1-0.7-2.2-0.9-3.3-0.4c-0.5,0.2-0.9,0.4-1.4,0.6c-0.3,0.2-0.6,0.3-0.9,0.5s-0.6,0.3-0.9,0.5c-0.5,0.3-1,0.6-1.4,0.8 c-0.5,0.3-1.2,0.6-1.8,0.9C729.8,199.6,729.6,199.8,729.3,200.1C729.4,200.2,729.3,200.2,729.3,200.1 C729.3,200.2,729.3,200.2,729.3,200.1L729.3,200.1L729.3,200.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_99_00000032644339238063252860000010560187789253680560_",
    gradientUnits: "userSpaceOnUse",
    x1: -876.9893,
    y1: -1100.5356,
    x2: -893.5844,
    y2: -1162.1606,
    gradientTransform: "matrix(13.5542 0 0 4.084 12758.5693 4833.4927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_99_00000032644339238063252860000010560187789253680560_)"
    },
    d: " M731.7,190c0.1-0.3,0.3-0.5,0.5-0.7c0.3-0.3,0.6-0.6,0.9-0.9c0.6-0.6,1.3-1.1,2-1.5c0.8-0.4,1.7-0.7,2.5-0.8 c0.6-0.1,1.2-0.1,1.9,0c0.9,0.1,1.8,0.4,2.7,0.8c1.3,0.6,2.4,1.8,3,3.1v0.1l0,0h-0.1c-0.8-1.1-2-1.8-3.3-2.2 c-0.7-0.2-1.5-0.3-2.3-0.3c-1.3,0-2.5,0.2-3.7,0.5c-0.7,0.2-1.5,0.5-2.2,0.9c-0.4,0.2-0.8,0.4-1.2,0.6 c-0.2,0.1-0.5,0.3-0.7,0.5C731.8,190.1,731.7,190.1,731.7,190C731.7,190.1,731.6,190,731.7,190L731.7,190L731.7,190z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_100_00000000214243319059296330000016352019176821799607_",
    gradientUnits: "userSpaceOnUse",
    x1: -869.635,
    y1: -1183.5647,
    x2: -887.675,
    y2: -1228.7607,
    gradientTransform: "matrix(12.4708 0 0 5.565 11722.7979 6920.144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_100_00000000214243319059296330000016352019176821799607_)"
    },
    d: " M733.8,181.5c0.1-0.1,0.2-0.1,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.6l1.6-1.7c0.4-0.4,0.8-0.7,1.2-1s0.9-0.6,1.3-0.9 c0.3-0.1,0.5-0.3,0.8-0.4c0.4-0.2,0.9-0.3,1.3-0.4c0.8-0.2,1.5-0.2,2.3-0.1c1.1,0.1,2.2,0.5,3.2,1.2v0.1l0,0h-0.1 c-1.3-0.5-2.7-0.5-4-0.1c-0.5,0.2-1.1,0.4-1.6,0.6c-0.3,0.2-0.7,0.3-1,0.5c-0.4,0.2-0.9,0.4-1.3,0.7s-0.9,0.5-1.3,0.8l-2.1,1.3 c-0.2,0.1-0.4,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.1C733.8,181.6,733.8,181.6,733.8,181.5C733.7,181.6,733.7,181.5,733.8,181.5 L733.8,181.5L733.8,181.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_101_00000023992904201510147210000016654594657490126268_",
    gradientUnits: "userSpaceOnUse",
    x1: -951.4182,
    y1: -1397.7495,
    x2: -952.61,
    y2: -1401.0026,
    gradientTransform: "matrix(188.5985 0 0 77.343 180322.1875 108432.4375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_101",
    style: {
      fill: "url(#Trazado_101_00000023992904201510147210000016654594657490126268_)"
    },
    d: "M790.6,76.1 c-0.5-0.2-1,0-1.3,0.3c-1.2,1.4-2.3,2.7-3.4,4.1c-21.8,26.1-42.3,50.7-101.5,47.8c-34.4-1.7-68.4,10.5-81.3,23.2 c-0.4,0.4-0.4,1,0,1.4l0.1,0.1c0.5,0.4,1.2,0.4,1.6,0c12.6-12.4,45.8-24.3,79.6-22.6c60.3,2.9,81.2-22.1,103.3-48.6 c1.1-1.4,2.3-2.7,3.4-4.1c0.3-0.4,0.3-1.1-0.2-1.4c0,0-0.1,0-0.1-0.1C790.8,76.2,790.7,76.1,790.6,76.1L790.6,76.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_102_00000139254266093195726930000012891217075008723368_",
    gradientUnits: "userSpaceOnUse",
    x1: -880.3079,
    y1: -1323.3264,
    x2: -895.1578,
    y2: -1340.2155,
    gradientTransform: "matrix(15.1537 0 0 14.8984 14149.1084 20107.9258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_102",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_102_00000139254266093195726930000012891217075008723368_)"
    },
    d: " M604.4,152c0.1,0.8,0.5,5.7,0.6,7.2c0.1,2,0.3,4.8-1.8,6.1c-0.7,0.5-2.2,1.1-3.1,0.3c-0.8-0.9-1.1-2-1-3.2 c0-0.2,0.2-1.1-0.1-1.2c-0.5-0.2-6,1.3-7.2-0.3c-0.8-1.1,2.7-3.5,2.6-3.7c-0.1-0.3-4.9-2.6-4.5-4.2 C590.3,151.1,594.6,150.3,604.4,152z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_103_00000023995285700970320360000015097178354631486393_",
    gradientUnits: "userSpaceOnUse",
    x1: -890.5234,
    y1: -1334.736,
    x2: -903.4034,
    y2: -1349.5239,
    gradientTransform: "matrix(17.4625 0 0 17.0126 16359.8311 23099.8262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_103",
    style: {
      fill: "url(#Trazado_103_00000023995285700970320360000015097178354631486393_)"
    },
    d: "M605.6,152 c0,0.2,0.1,0.8,0.1,1.6c0.1,1.8,0.4,4.6,0.4,5.6c0.1,2.1,0.3,5.4-2.3,7c-1.8,1.1-3.5,1.1-4.6,0.1c-1-1.1-1.5-2.5-1.4-4 c-2.3,0.3-5.8,0.8-7.1-0.9c-1-1.4,0.6-3,1.8-4.2c-1.8-1.1-4.3-2.8-3.9-4.6c0.6-2.8,5.8-3.3,15.8-1.6c0.1,0,0.1,0,0.2,0.1 C605.2,151.2,605.5,151.5,605.6,152L605.6,152z M591,153.1c0,0.3,0.6,1,3.1,2.5c0.9,0.6,1.2,0.8,1.4,1.3c0.2,0.6-0.2,1-0.9,1.6 c-0.7,0.5-1.3,1.2-1.8,1.9c0.4,0.2,1.4,0.3,4.5-0.1c1.1-0.2,1.6-0.2,2,0c1,0.4,0.9,1.5,0.8,2.1v0.1c-0.1,0.9,0.1,1.7,0.6,2.4 c0.3,0.2,1,0,1.7-0.4c1.6-1,1.4-3.4,1.3-5.2c-0.1-1-0.3-3.8-0.4-5.6c0-0.3,0-0.5-0.1-0.7C591.7,151,591.1,153.1,591,153.1 L591,153.1L591,153.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_104_00000049941672949694186510000016284946281793461398_",
    gradientUnits: "userSpaceOnUse",
    x1: -921.6092,
    y1: -1251.0244,
    x2: -928.4892,
    y2: -1281.0824,
    gradientTransform: "matrix(32.6815 0 0 8.3751 30948.0273 10853.4619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104",
    style: {
      fill: "url(#Trazado_104_00000049941672949694186510000016284946281793461398_)"
    },
    d: "M629,137.3 c-0.2-0.1-0.5-0.1-0.8,0c-0.4,0.1-0.8,0.1-1.2,0.1c-0.2,0-0.4,0-0.6,0c-1.9,0.1-3.8,0.1-5.8-0.1c-4.9-0.6-9.8-1.7-14.5-3.4 l-1.5-0.5c-2-0.6-4-1.3-5.9-2.1c-0.6-0.3-1.2-0.1-1.5,0.5c-0.2,0.5,0,1.2,0.6,1.4l0,0c2,0.8,4.1,1.6,6.1,2.2 c0.5,0.2,1,0.3,1.5,0.5c4.9,1.8,9.9,2.9,15,3.5c2.1,0.2,4.1,0.2,6.2,0.1c0.2,0,0.4,0,0.5,0c0.6,0,1.2-0.1,1.8-0.2 c0.5-0.1,0.8-0.7,0.7-1.2V138C629.6,137.6,629.3,137.4,629,137.3L629,137.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_105_00000158735164693964892660000013251010694791337658_",
    gradientUnits: "userSpaceOnUse",
    x1: -859.4879,
    y1: -1282.696,
    x2: -878.0989,
    y2: -1306.7571,
    gradientTransform: "matrix(12.0835 0 0 10.476 11204.8682 13821.7754)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_105_00000158735164693964892660000013251010694791337658_)"
    },
    d: " M598.3,132.4c-1.6,1.1-3.7,3.3-6,3.4c-4.6,0.3-7.2-4.5-4-4.9c0.6,0,1.2,0,1.7-0.2c0.2-0.1-1.1-1-1.2-1.2 c-0.7-0.6-1.1-1.5-1-2.3c0.3-1.1,1.8-1.4,3.3-0.6c0.3,0.2,1.3,1.1,1.7,1s0.4-0.8,0.5-1c0.3-0.8,1.1-1.3,2-1.1 c1.1,0.2,2.2,0.8,2.9,1.7C599.6,128.8,598.6,130.8,598.3,132.4L598.3,132.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_106_00000127762954242535161130000009291513382824620462_",
    gradientUnits: "userSpaceOnUse",
    x1: -875.2745,
    y1: -1304.9799,
    x2: -890.8955,
    y2: -1324.9919,
    gradientTransform: "matrix(14.4053 0 0 12.5947 13427.9648 16820.0664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106",
    style: {
      fill: "url(#Trazado_106_00000127762954242535161130000009291513382824620462_)"
    },
    d: "M599.1,126.5 c1.5,1.8,0.9,3.8,0.5,5.3c-0.1,0.3-0.2,0.6-0.2,0.9c-0.1,0.2-0.2,0.5-0.4,0.6c-0.4,0.3-0.8,0.6-1.2,0.9 c-1.4,1.1-3.2,2.5-5.4,2.7c-3.5,0.2-6.3-2-6.7-4.2c-0.3-1.2,0.5-2.5,1.8-2.7c0.1,0,0.1,0,0.2,0c-0.8-0.8-1.2-1.9-1-3 c0.2-0.8,0.8-1.4,1.6-1.6c1.1-0.3,2.4-0.1,3.4,0.5c0.2,0.1,0.4,0.2,0.5,0.4l0,0c0.5-1.3,1.8-2,3.1-1.8c0.4,0,0.7,0.1,1.1,0.2 C597.5,125,598.4,125.6,599.1,126.5z M590.8,127.8c-0.1-0.1-0.2-0.2-0.3-0.2c-0.4-0.3-0.9-0.4-1.3-0.3c-0.1,0-0.2,0.1-0.3,0.3 c-0.1,0.2,0.1,0.8,0.7,1.3c0,0,0.1,0.1,0.2,0.2c0.8,0.6,1.4,1.1,1.4,1.7c0,0.3-0.2,0.7-0.5,0.8c-0.6,0.3-1.2,0.4-1.8,0.4 c-0.1,0-0.3,0-0.4,0c-0.5,0.1-0.5,0.2-0.5,0.5c0.2,0.9,1.7,2.5,4.1,2.3c1.4-0.1,2.8-1.2,4.1-2.2c0.4-0.3,0.7-0.6,1-0.8 c0-0.2,0.1-0.4,0.2-0.6c0.4-1.5,0.6-2.6-0.1-3.5c-0.5-0.6-1.2-1.1-2-1.2c-0.4-0.1-0.7,0.1-0.8,0.5v0.1 c-0.1,0.7-0.5,1.3-1.2,1.5c-0.3,0.1-0.7,0.1-1,0C591.7,128.4,591.3,128.1,590.8,127.8L590.8,127.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_107_00000171720862685246934490000008990732839448339349_",
    gradientUnits: "userSpaceOnUse",
    x1: -924.1337,
    y1: -1372.7965,
    x2: -930.6358,
    y2: -1380.6725,
    gradientTransform: "matrix(34.59 0 0 31.9527 32807.7422 44228.9414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107",
    style: {
      fill: "url(#Trazado_107_00000171720862685246934490000008990732839448339349_)"
    },
    d: "M662.3,129.2 c-0.3-0.1-0.7-0.1-1,0.1l-0.2,0.1c-7.7,4.6-15.7,9.4-22.1,15.9c-2.2,2.3-4.1,4.9-5.7,7.7c-0.4,0.7-0.9,1.4-1.3,2s-1,1.3-1.5,2 c-0.6,0.8-1.2,1.6-1.7,2.4c-0.3,0.5-0.1,1.1,0.4,1.4c0,0,0,0,0.1,0c0.5,0.3,1.2,0.2,1.6-0.3c0.5-0.8,1-1.5,1.6-2.3 c0.5-0.7,1.1-1.4,1.6-2.2c0.5-0.7,0.9-1.4,1.3-2.1c1.5-2.6,3.4-5.1,5.4-7.3c6.2-6.3,14.1-11,21.7-15.5l0.2-0.1 c0.5-0.3,0.6-0.9,0.4-1.3l-0.1-0.1C662.8,129.4,662.6,129.3,662.3,129.2L662.3,129.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_108_00000013886908161196647610000010777374217189796005_",
    gradientUnits: "userSpaceOnUse",
    x1: -862.6299,
    y1: -1315.1058,
    x2: -881.1429,
    y2: -1333.7389,
    gradientTransform: "matrix(12.1508 0 0 13.5034 11302.167 18141.0273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_108_00000013886908161196647610000010777374217189796005_)"
    },
    d: " M629.4,160c3.8,3.5,2.4,9.1,1.3,11c-0.5,0.8-1.5,2-2.7,1.3c-0.8-0.6-1.3-1.5-1.3-2.5c0-0.2,0.1-1.1-0.1-1.3 c-0.3-0.2-0.9,0.2-1.1,0.3c-0.9,0.4-3.1,1.5-3.9,0.2c-0.6-1.1,0.3-2.5,0.9-3.4c0.2-0.3,0.8-0.7,0.8-1.1c0-0.3-0.5-0.7-0.7-0.9 c-0.7-0.7-3.6-2.7-2.6-3.7C620.5,159.6,624.2,158,629.4,160z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_109_00000057123356141187090230000004304534901951010217_",
    gradientUnits: "userSpaceOnUse",
    x1: -877.8354,
    y1: -1328.6599,
    x2: -893.3864,
    y2: -1344.7679,
    gradientTransform: "matrix(14.4711 0 0 15.6191 13523.873 21135.2051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    style: {
      fill: "url(#Trazado_109_00000057123356141187090230000004304534901951010217_)"
    },
    d: "M629.8,159 c0.1,0.1,0.3,0.1,0.4,0.2c4.3,3.9,2.8,10.1,1.5,12.3c-0.5,1-1.4,1.7-2.5,2c-0.6,0.1-1.3,0-1.9-0.4c-1.1-0.7-1.8-1.9-1.9-3.1 c-1.1,0.6-2.4,0.8-3.7,0.6c-0.6-0.2-1-0.6-1.3-1.1c-0.7-1.2-0.4-2.7,0.9-4.4c0.1-0.1,0.2-0.3,0.4-0.4l0,0 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.3-0.3-0.5-0.5c-1.3-1.1-2.5-2.2-2.6-3.4c0-0.5,0.2-0.9,0.5-1.2c0.9-0.8,4.8-2.4,10.1-0.6 C629.4,158.9,629.6,159,629.8,159L629.8,159z M629.4,160L629.4,160z M622.7,162.5c0.3,0.2,0.5,0.5,0.7,0.6l0.1,0.1 c0.5,0.4,0.8,0.9,0.9,1.5c-0.1,0.6-0.4,1.1-0.8,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.9,1.2-1,2-0.9,2.3c0.2,0,0.7,0.1,2.2-0.6 l0.3-0.1c0.6-0.4,1.4-0.5,2.1-0.2c0.6,0.5,0.9,1.2,0.7,2c0,0.1,0,0.1,0,0.1c-0.3,0.4-0.3,1.1,0.2,1.4c0.4,0.3,1.1,0.3,1.4-0.2 c0.1-0.2,0.2-0.4,0.2-0.6c0.9-1.4,2.2-6.5-0.9-9.6c-4.1-1.4-7-0.5-7.8-0.1C621.5,161.4,622.1,162,622.7,162.5L622.7,162.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_110_00000174569627545222671850000015180021396076864408_",
    gradientUnits: "userSpaceOnUse",
    x1: -934.6555,
    y1: -1345.9115,
    x2: -939.1215,
    y2: -1358.8315,
    gradientTransform: "matrix(50.3531 0 0 19.489 47938.2109 26566.2539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    style: {
      fill: "url(#Trazado_110_00000174569627545222671850000015180021396076864408_)"
    },
    d: "M659.4,110.8 c-0.4-0.2-0.9,0-1.2,0.3c-0.4,0.4-0.3,1,0.1,1.4l0.1,0.1c4.4,3.5,9.9,5.7,15.1,7.8l0.2,0.1c10.7,4.4,21.9,7.6,33.3,9.7 c0.6,0.1,1.2-0.2,1.3-0.8l0,0c0.1-0.6-0.4-1.2-1-1.2c-11.2-2.1-22.2-5.3-32.8-9.6l-0.2-0.1c-5.1-2-10.4-4.2-14.5-7.5 C659.7,110.9,659.5,110.9,659.4,110.8L659.4,110.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_111_00000122721410608008162400000011559874355322635393_",
    gradientUnits: "userSpaceOnUse",
    x1: -861.751,
    y1: -1305.625,
    x2: -880.1921,
    y2: -1325.74,
    gradientTransform: "matrix(12.2004 0 0 12.5049 11377.3613 16672.582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_111_00000122721410608008162400000011559874355322635393_)"
    },
    d: " M658.8,112.4c-0.9,2.6-9,5.9-11,2.9c-0.7-0.9-0.6-2.2,0.1-3.1c0.4-0.5,1-1,0.9-1.6c-0.1-1.5-1.9-2.7-1.2-4.3 c0.6-1.3,2.2-1.8,3.4-1.1c0.1,0,0.2,0.1,0.3,0.2c0.4,0.2,1.1,1,1.6,0.9s0.8-0.6,1-0.9c0.4-0.5,0.9-0.9,1.5-1.2 C658.3,103.1,660.8,109.5,658.8,112.4L658.8,112.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_112_00000008853823010195935740000000807201467891114141_",
    gradientUnits: "userSpaceOnUse",
    x1: -877.0645,
    y1: -1321.4641,
    x2: -892.5516,
    y2: -1338.6741,
    gradientTransform: "matrix(14.5228 0 0 14.6196 13601.043 19665.1738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    style: {
      fill: "url(#Trazado_112_00000008853823010195935740000000807201467891114141_)"
    },
    d: "M658.7,104.3 c1.9,2.1,2.8,6.1,1.2,8.6c-0.9,2.3-5.4,4.4-8.5,4.6c-2.1,0.1-3.7-0.5-4.5-1.7c-0.9-1.3-0.9-3,0.1-4.2c0.1-0.2,0.3-0.3,0.4-0.5 c0.1-0.2,0.4-0.4,0.4-0.5c-0.1-0.5-0.3-0.9-0.6-1.3c-0.7-1-1-2.2-0.6-3.4c0.4-0.9,1.2-1.6,2.1-1.9c1.1-0.3,2.3-0.2,3.3,0.4 c0.2,0.1,0.4,0.3,0.7,0.5c0,0,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.2,0.2-0.2l0.1-0.1c0.5-0.7,1.2-1.2,2-1.5c0.6-0.2,1.3-0.2,1.9,0 C657.6,103.3,658.2,103.7,658.7,104.3L658.7,104.3z M651.1,106.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.2-0.9-0.3-1.3-0.2 c-0.3,0.1-0.6,0.4-0.8,0.7c-0.2,0.5,0,0.8,0.5,1.7c0.4,0.7,0.7,1.4,0.8,2.2c0,0.7-0.3,1.4-0.8,1.9c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.5,0.6-0.5,1.4-0.1,2s1.5,0.7,2.3,0.7c2.8-0.2,6.2-2.1,6.7-3.4c0-0.1,0.1-0.1,0.1-0.2c1.1-1.6,0.4-4.8-0.9-6.2 c-0.6-0.7-0.9-0.5-1.1-0.5c-0.4,0.2-0.7,0.4-1,0.8l-0.1,0.1c-0.4,0.6-1,1.1-1.7,1.2c-0.3,0-0.6,0-0.9-0.1 C651.8,106.9,651.4,106.7,651.1,106.4L651.1,106.4z M660,112.8L660,112.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_113_00000126285453208260471180000007388136772887959699_",
    gradientUnits: "userSpaceOnUse",
    x1: -912.1596,
    y1: -1363.307,
    x2: -921.2276,
    y2: -1373.191,
    gradientTransform: "matrix(24.7948 0 0 25.4637 23511.2305 35034.2852)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    style: {
      fill: "url(#Trazado_113_00000126285453208260471180000007388136772887959699_)"
    },
    d: "M739.8,120.7 c-0.3-0.1-0.5-0.1-0.8,0c-3.4,1.1-6.5,4-8.7,6.1c-5.5,5.3-10.3,11.2-14.4,17.7c-0.3,0.5-0.1,1.1,0.4,1.4c0,0,0,0,0.1,0 c0.5,0.3,1.2,0.2,1.6-0.3c3.9-6.3,8.7-12.1,14.1-17.3c2.1-2,4.9-4.6,7.9-5.6c0.5-0.2,0.8-0.7,0.7-1.2c0,0,0-0.1-0.1-0.1 C740.4,121.1,740.1,120.8,739.8,120.7L739.8,120.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_114_00000012439771619396117350000007535743657328579207_",
    gradientUnits: "userSpaceOnUse",
    x1: -860.0277,
    y1: -1293.691,
    x2: -879.6428,
    y2: -1316.8551,
    gradientTransform: "matrix(11.5216 0 0 10.8544 10787.4443 14375.8887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_114_00000012439771619396117350000007535743657328579207_)"
    },
    d: " M717.3,145.2c0-0.1,1.5,2.1,1.5,2.2c0,0.2,0.1,0.3,0.1,0.5c0.1,0.5,0.2,1,0.3,1.6c0.3,1.6-0.1,3.3-1.1,4.5 c-1.2,1.2-2.5,1-3.2-0.6c-0.1-0.2-0.3-1.3-0.6-1.3c-0.4,0-0.9,0.3-1.3,0.5c-1.2,0.6-3.3,1.8-4.7,0.7c-0.4-0.4-0.6-0.9-0.5-1.4 c0.1-1.3,1.4-2,1.8-3.2c0.3-1.1-1.2-2.2-1.3-3.3c-0.1-0.9,0.8-1.5,1.7-1.4C711.8,143.9,715.5,145.1,717.3,145.2L717.3,145.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_115_00000091726560618109625250000007876702795191177894_",
    gradientUnits: "userSpaceOnUse",
    x1: -876.4333,
    y1: -1313.5765,
    x2: -892.7474,
    y2: -1332.9675,
    gradientTransform: "matrix(13.8528 0 0 12.9819 13019.5361 17386.6133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_115",
    style: {
      fill: "url(#Trazado_115_00000091726560618109625250000007876702795191177894_)"
    },
    d: "M719.9,147.2 l0.1,0.5c0.1,0.6,0.2,1.1,0.3,1.7c0.4,1.9-0.1,3.9-1.4,5.3c-1.1,1.3-3,1.4-4.3,0.3c-0.4-0.4-0.7-0.8-0.9-1.3 c0-0.1-0.1-0.2-0.1-0.3c0,0-0.1,0-0.1,0.1l-0.2,0.1c-1.4,0.7-3.9,2-5.8,0.5c-0.7-0.6-1-1.4-0.9-2.3c0.1-0.9,0.5-1.7,1.2-2.4 c0.3-0.3,0.5-0.7,0.7-1.1c0.1-0.2-0.2-0.6-0.5-1c-0.4-0.6-0.7-1.2-0.8-1.9s0.2-1.3,0.7-1.8c0.6-0.5,1.4-0.8,2.2-0.7 c1.2,0.1,2.4,0.4,3.6,0.7c1.2,0.3,2.3,0.5,3.5,0.7c0.1,0,0.2,0,0.4,0l0,0C718.5,144.5,719.9,147.1,719.9,147.2L719.9,147.2z  M708.9,152.4c0.7,0.5,2.3-0.3,3.1-0.8l0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0.5-0.4,1.1-0.5,1.7-0.5c1.1,0.1,1.4,1.2,1.6,1.9 c0,0.1,0,0.2,0,0.2c0.2,0.4,0.4,0.6,0.5,0.6s0.4-0.1,0.8-0.4c1-1,1-2.8,0.9-3.7c-0.1-0.5-0.1-0.9-0.3-1.5l-0.1-0.3 c-0.2-0.3-0.7-1-1-1.5c-1.2-0.2-2.3-0.4-3.5-0.7c-1-0.3-2.1-0.5-3.2-0.6c-0.2,0-0.4,0-0.5,0.1c-0.1,0-0.1,0.1-0.1,0.2 c0.1,0.4,0.3,0.7,0.5,1c0.7,0.7,0.9,1.7,0.8,2.7c-0.2,0.6-0.6,1.2-1,1.7c-0.4,0.4-0.6,0.8-0.7,1.3 C708.9,152.1,708.9,152.3,708.9,152.4L708.9,152.4L708.9,152.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_116_00000025414275103370480950000003680899320299569550_",
    gradientUnits: "userSpaceOnUse",
    x1: -951.5569,
    y1: -1385.2887,
    x2: -952.6969,
    y2: -1390.8008,
    gradientTransform: "matrix(197.3754 0 0 45.6337 188722.7188 63522.9453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_116",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_116_00000025414275103370480950000003680899320299569550_)"
    },
    d: " M791.9,77.7c-4,3.6-8.2,6.9-12.6,10c-4.5,3.2-9.4,5.9-14.4,8.1c-3,1.3-6,2.4-9.1,3.4c-2.1,0.6-4.3,1.1-6.5,1.5 c-8.9,1.1-17.9,0.8-26.6-1.1c-8.8-1.7-17.3-4.5-25.3-8.4c-2.7-1.3-5.3-2.7-7.9-4.1c-10.1-5.7-19.6-12.4-30.1-17.5 c-9.8-4.7-20.1-8-30.7-9.8c-10.9-1.9-22-2.4-32-0.9c-0.6,0.1-1.2-0.3-1.4-0.9c-0.1-0.5,0.2-1.1,0.8-1.2h0.1 c10.2-1.7,21.6-1.3,32.8,0.6c10.9,1.8,21.6,5.1,31.6,9.8c10.6,5.1,20.2,11.7,30.5,17.4c2.5,1.4,5.1,2.7,7.7,4 c7.8,3.6,16,6.3,24.4,7.9c8.3,1.7,16.8,1.9,25.2,0.8c2.5-0.4,5-1,7.4-1.9c2.5-0.8,4.8-1.8,7.2-2.8c4.8-2.1,9.4-4.8,13.7-7.8 c4.2-3.1,8.3-6.4,12.2-9.9c0.9-0.7,2.2-0.7,3.1,0.1c0.8,0.7,0.9,1.8,0.2,2.6C792,77.6,791.9,77.7,791.9,77.7L791.9,77.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_117_00000129185482963885621790000009039635992139293631_",
    gradientUnits: "userSpaceOnUse",
    x1: -931.7066,
    y1: -1340.2402,
    x2: -936.4286,
    y2: -1353.3622,
    gradientTransform: "matrix(47.6257 0 0 19.1782 45217.4297 26065.8594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_117",
    style: {
      fill: "url(#Trazado_117_00000129185482963885621790000009039635992139293631_)"
    },
    d: "M590.8,53.7 c2.1,0.8,4.2,1.7,6.2,2.8c0.3,0.2,0.5,0.5,0.6,0.8s-0.1,0.7-0.3,0.9c-4.7,4.2-9.4,8.1-15.8,10.1c-5.1,1.6-11.8,1.5-18.4-0.2 c-2.4-0.7-4.7-1.6-7-2.6c-0.8-0.4-1.6-0.7-2.4-1.1c-0.3-0.1-0.7-0.3-1.2-0.5c-2-0.7-2.5-0.9-2.4-1.8c0.1-0.9,0.9-1,2.2-1 c0.6,0,1.5-0.1,1.9-0.1c1.6-0.4,3.1-1.2,4.4-2.2c0.9-0.7,1.7-1.4,2.5-2.1c0.7-0.6,1.4-1.3,2.2-1.9c2.1-1.6,4.5-2.8,7-3.7 c5.7-2,12.3-0.4,18.3,1.7C589.2,53.1,590,53.4,590.8,53.7L590.8,53.7z M557,63.6c2.1,1,4.3,1.9,6.6,2.5 c6.1,1.6,12.5,1.7,17.1,0.2c5.5-1.7,9.7-5,13.9-8.7c-1.4-0.7-2.9-1.4-4.5-1.9c-6.3-2.3-13.4-4.5-19.1-2.6 c-2.3,0.8-4.4,1.9-6.3,3.3c-0.7,0.6-1.4,1.1-2.1,1.8c-0.8,0.8-1.7,1.5-2.7,2.2c-1.4,1.1-2.9,1.9-4.5,2.4 C555.9,63.1,556.5,63.4,557,63.6L557,63.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_118_00000010311096344120464550000008588151413259673257_",
    gradientUnits: "userSpaceOnUse",
    x1: -914.3323,
    y1: -1375.3856,
    x2: -922.3593,
    y2: -1382.4526,
    gradientTransform: "matrix(28.0211 0 0 35.5971 26472.1426 49315.8789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118",
    style: {
      fill: "url(#Trazado_118_00000010311096344120464550000008588151413259673257_)"
    },
    d: "M613.3,57.1 c0.3,0.2,0.5,0.5,0.5,0.8c0.3,6.2,0.4,12.2-2.2,17.8c-2,4.5-6.5,8.9-12.1,12c-2.1,1.1-4.4,2-6.7,2.7c-0.8,0.3-1.6,0.5-2.4,0.8 c-0.3,0.1-0.7,0.3-1.2,0.5c-1.9,0.8-2.3,1-3,0.3s-0.2-1.3,0.6-2.2c0.4-0.4,0.8-0.9,1.1-1.3c0.7-1.4,1.1-2.9,1.1-4.5 c0-1.1,0-2.1-0.1-3.2c-0.1-0.9-0.1-1.9-0.1-2.8c0.1-2.5,0.6-5,1.6-7.3c2.4-5.9,9.3-9.2,15.5-11.8c2-0.8,4.1-1.5,6.2-2 c0.2-0.1,0.5,0,0.7,0C613.1,57,613.2,57,613.3,57.1L613.3,57.1z M591.9,88.5c2.2-0.6,4.3-1.5,6.3-2.5c5.3-2.9,9.4-7,11.3-11.1 c2.2-4.9,2.3-10.1,2.1-15.5c-1.5,0.4-3,0.9-4.4,1.5c-5.9,2.5-12.3,5.5-14.4,10.8c-0.9,2.1-1.4,4.3-1.5,6.6c0,0.9,0,1.7,0.1,2.7 c0.1,1.1,0.1,2.3,0.1,3.4c0,1.6-0.4,3.2-1,4.7C590.9,88.8,591.4,88.7,591.9,88.5L591.9,88.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_119_00000114776311742952180170000008692405817552964493_",
    gradientUnits: "userSpaceOnUse",
    x1: -915.1243,
    y1: -1377.2831,
    x2: -922.9283,
    y2: -1383.9501,
    gradientTransform: "matrix(28.826 0 0 37.7467 27256.0664 52322.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_119",
    style: {
      fill: "url(#Trazado_119_00000114776311742952180170000008692405817552964493_)"
    },
    d: "M601.5,22.1 c0.3,0.5,0.7,1,1,1.5c1.2,1.2,2.7,2.2,4.3,2.8c1,0.5,2.1,0.9,3.3,1.3c1,0.3,1.9,0.7,2.9,1.1c2.5,1.1,4.9,2.6,7,4.4 c5.3,4.5,6.6,11.7,7.3,18.1c0.2,2,0.3,4.1,0.2,6.1c0,0.3-0.2,0.6-0.5,0.8s-0.7,0.2-1,0.1c-6.4-2.3-12.6-4.7-17.6-9.3 c-4.3-4.1-7.3-9.5-8.6-15.3c-0.5-2.2-0.7-4.5-0.7-6.8c0-0.8-0.1-1.6-0.1-2.4c0-0.3-0.1-0.7-0.1-1.2c-0.2-1.9-0.3-2.4,0.6-2.7 c0.2-0.1,0.5-0.1,0.7,0C600.7,20.8,601,21.3,601.5,22.1z M625,51.4c-0.7-6-1.9-12.8-6.6-16.7c-1.9-1.6-4-3-6.3-4 c-0.9-0.4-1.8-0.7-2.7-1c-1.1-0.4-2.3-0.8-3.5-1.4c-1.7-0.7-3.2-1.7-4.5-2.8c0,0.5,0,1,0.1,1.6c0,2.1,0.2,4.3,0.7,6.4 c1.3,5.6,4.3,10.9,7.9,14.2c4.3,3.9,9.7,6.2,15.3,8.2C625.2,54.3,625.2,52.8,625,51.4L625,51.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_120_00000180335991618251133880000007118334557512737417_",
    gradientUnits: "userSpaceOnUse",
    x1: -929.0664,
    y1: -1356.2463,
    x2: -934.4575,
    y2: -1366.9124,
    gradientTransform: "matrix(41.7211 0 0 23.5923 39632.9102 32336.248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_120",
    style: {
      fill: "url(#Trazado_120_00000180335991618251133880000007118334557512737417_)"
    },
    d: "M663.7,73.1 c0.2,0.3,0.2,0.6,0.1,0.9c-0.2,0.6-0.3,1.2-0.4,1.8c-0.8,3.9-1.9,9.7-14.3,14.6c-5.7,2.2-11.6,3.7-17.6,4.5 c-3.7,0.5-8.3,0.9-9.1,0c-0.3-0.3-0.9-1,2-5.6c3.1-5,14.9-20.9,38.5-16.8c0.1,0,0.1,0,0.2,0.1 C663.3,72.7,663.5,72.8,663.7,73.1z M648.1,88.4c11.3-4.5,12.3-9.7,13-13.2c0.1-0.3,0.1-0.6,0.2-0.9 c-23.9-3.3-34.3,14.5-36.4,19C632.8,93,640.7,91.4,648.1,88.4L648.1,88.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_121_00000174601858027586614620000016146326284750938798_",
    gradientUnits: "userSpaceOnUse",
    x1: -920.1653,
    y1: -1198.5273,
    x2: -927.0193,
    y2: -1236.5414,
    gradientTransform: "matrix(32.8087 0 0 6.612 31038.2441 8282.8105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_121",
    style: {
      fill: "url(#Trazado_121_00000174601858027586614620000016146326284750938798_)"
    },
    d: "M597.5,56.6 c-0.2-0.1-0.4-0.1-0.5-0.1c-2.6,0.3-5.4,0.4-8,0.6c-3.6,0.2-7.3,0.4-10.9,0.9c-4,0.7-8,1.7-11.9,3.1c-0.5,0.2-0.8,0.7-0.7,1.2 c0,0,0,0.1,0.1,0.1c0.3,0.6,0.9,0.8,1.5,0.6c3.7-1.3,7.5-2.3,11.4-3c3.5-0.5,7.2-0.7,10.7-0.9c2.7-0.1,5.4-0.3,8.1-0.6 c0.6,0,1-0.5,1-1v-0.1C598.2,57.1,597.9,56.7,597.5,56.6L597.5,56.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_122_00000126315154458963291440000000049681492306462387_",
    gradientUnits: "userSpaceOnUse",
    x1: -889.4577,
    y1: -1358.4268,
    x2: -902.1017,
    y2: -1368.5059,
    gradientTransform: "matrix(17.7842 0 0 24.9704 16675.1855 34272.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_122",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_122_00000126315154458963291440000000049681492306462387_)"
    },
    d: " M596,81.5c0.5-0.8,1-1.6,1.6-2.4c1.3-1.8,2.8-3.5,4.1-5.3c0.9-1.2,1.7-2.5,2.4-3.7c1.2-1.9,2.2-3.9,3.4-5.8c1-1.7,2-3.3,3-5 c0.4-0.7,0.8-1.4,1.1-2.1c0.3-0.5,1-0.7,1.5-0.4c0.5,0.2,0.8,0.8,0.6,1.4c0,0,0,0,0,0.1c-0.4,0.7-0.9,1.5-1.4,2.2 c-1.1,1.6-2.3,3.1-3.4,4.8c-1.3,1.9-2.5,3.7-3.8,5.5c-0.9,1.2-1.8,2.4-2.7,3.6c-1.4,1.7-3,3.3-4.5,5c-0.6,0.7-1.2,1.5-1.7,2.3 C596.1,81.6,596,81.7,596,81.5C595.9,81.6,595.9,81.6,596,81.5C596,81.6,596,81.5,596,81.5L596,81.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_123_00000056396629390731107330000002060258193916700093_",
    gradientUnits: "userSpaceOnUse",
    x1: -887.3547,
    y1: -1356.7257,
    x2: -900.3287,
    y2: -1367.0558,
    gradientTransform: "matrix(17.3331 0 0 24.3637 16256.5293 33390.2422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_123",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_123_00000056396629390731107330000002060258193916700093_)"
    },
    d: " M609.5,33.8c1.9,3.2,4,6.4,6.2,9.4c4.2,5.8,8,9.8,9.8,11.9c0.5,0.5,0.8,1.1,1.2,1.7c0.2,0.5-0.1,1.1-0.6,1.3H626 c-0.6,0.2-1.2-0.1-1.5-0.7c-0.5-0.9-1.1-1.7-1.7-2.5c-1.8-2.4-4.7-6.2-7.9-11.2C612.9,40.5,611.1,37.3,609.5,33.8 C609.4,33.8,609.4,33.8,609.5,33.8C609.4,33.7,609.4,33.7,609.5,33.8C609.5,33.7,609.5,33.7,609.5,33.8L609.5,33.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_124_00000128451483875288578140000000783241825584816524_",
    gradientUnits: "userSpaceOnUse",
    x1: -919.2643,
    y1: -1329.3757,
    x2: -926.5244,
    y2: -1344.9187,
    gradientTransform: "matrix(30.9824 0 0 16.1799 29359.3066 21842.2227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_124",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_124_00000128451483875288578140000000783241825584816524_)"
    },
    d: " M636.2,87.3c1.3-1.1,2.6-2.1,4.1-3.1c2.1-1.4,4.4-2.7,6.6-3.9c2.4-1.3,4.9-2.6,7.3-3.8c3.7-1.8,7.5-3.5,11.2-5.2 c0.6-0.2,1.2,0,1.6,0.5c0.3,0.5,0.1,1.1-0.4,1.3c0,0-0.1,0-0.1,0.1c-3.9,1.5-7.8,3-11.6,4.5c-2.5,1-5.1,2.1-7.5,3.3 c-2.3,1.1-4.7,2.2-6.9,3.5C639,85.4,637.6,86.4,636.2,87.3C636.2,87.4,636.2,87.4,636.2,87.3C636.1,87.4,636.1,87.3,636.2,87.3 L636.2,87.3L636.2,87.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_125_00000016759928229081563060000003230624996813714345_",
    gradientUnits: "userSpaceOnUse",
    x1: -882.1082,
    y1: -1373.1289,
    x2: -896.4982,
    y2: -1380.7839,
    gradientTransform: "matrix(15.6272 0 0 32.8727 14684.6816 45453.2539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_125",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_125_00000016759928229081563060000003230624996813714345_)"
    },
    d: " M685.1,83c-0.2-2.2-2.8-9.1-5.6-16c-2.8-6.7-5.9-13.3-7.7-15.6c0,0,0-0.1,0-0.2l0,0c0.1,0,0.1,0,0.2,0 c1.9,2.3,5.4,8.8,8.6,15.4c3.4,7,6.4,14.1,6.7,16.3c0.1,0.6-0.4,1.1-0.9,1.1h-0.1C685.8,84.1,685.3,83.6,685.1,83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_126_00000052816391447113480790000017067619798421462933_",
    gradientUnits: "userSpaceOnUse",
    x1: -924.1749,
    y1: -1369.7349,
    x2: -930.7159,
    y2: -1378.2389,
    gradientTransform: "matrix(34.3809 0 0 29.5911 32696.5898 40827.2539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_126",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_126_00000052816391447113480790000017067619798421462933_)"
    },
    d: " M750.3,100c-0.8-0.6-6.2-2-15-9.7c-6.5-5.9-12.4-12.4-17.5-19.5c0,0,0-0.1,0-0.2l0,0c0.1,0,0.1,0,0.2,0 c5.4,6.8,11.6,13.1,18.3,18.7c6.5,5.2,11.1,7.3,13.4,8.2c0.6,0.2,1.3,0.5,1.9,0.8c0.5,0.3,0.7,0.9,0.4,1.4c0,0,0,0.1-0.1,0.1 C751.5,100.2,750.8,100.3,750.3,100z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_127_00000009578555979812419870000003763243732402717631_",
    gradientUnits: "userSpaceOnUse",
    x1: -930.7304,
    y1: -1307.2156,
    x2: -935.9844,
    y2: -1327.4166,
    gradientTransform: "matrix(42.8141 0 0 12.4593 40747.6641 16602.3359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_127",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_127_00000009578555979812419870000003763243732402717631_)"
    },
    d: " M732,100.4c-6.6,2.9-13.4,5.3-20.3,7.2c-6.5,1.6-12.7,2.4-21.7,3.2c-0.1,0-0.1,0-0.2-0.1c0-0.1,0-0.1,0.1-0.1l0,0 c8.8-1.1,15-2.2,21.3-4.1c6.8-2.2,13.3-4.8,19.7-8c0.6-0.2,1.2,0,1.6,0.5c0.3,0.5,0.1,1.1-0.3,1.3 C732.1,100.3,732,100.4,732,100.4L732,100.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_128_00000009583730095413245710000008211395574199674541_",
    gradientUnits: "userSpaceOnUse",
    x1: -913.1268,
    y1: -1379.8827,
    x2: -921.5477,
    y2: -1386.2758,
    gradientTransform: "matrix(26.7081 0 0 39.3655 25290.1816 54632.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_128",
    style: {
      fill: "url(#Trazado_128_00000009583730095413245710000008211395574199674541_)"
    },
    d: "M684.4,53.7 c6.2,6.5,4.2,17.8,1.3,23.8c-0.2,0.4-0.6,0.6-1.1,0.6c-0.3,0-0.8-0.1-5.2-2.3c-1.7-0.9-3.4-2-4.9-3.2 c-7.8-6.2-9.4-15.3-10.8-23.4c-0.2-0.9-0.5-2.5-0.8-4c-1.3-5.7-1.2-5.7-0.7-6.2c0.2-0.2,0.5-0.3,0.8-0.3c0.1,0,0.1,0,0.1,0 C665.3,39.6,682.6,51.9,684.4,53.7L684.4,53.7z M682.7,55.1c-2.1-2.2-13.6-10-18.2-13.1c0.2,0.9,0.4,2,0.6,3 c0.4,1.6,0.7,3.2,0.9,4.1c1.4,7.7,2.9,16.4,10,22c1.4,1.1,2.9,2.1,4.5,2.9c1.7,0.9,2.8,1.4,3.5,1.7 C686.8,69.1,687.4,59.9,682.7,55.1L682.7,55.1z M684.8,76.1L684.8,76.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_129_00000062898415211786780430000001306135506434348199_",
    gradientUnits: "userSpaceOnUse",
    x1: -936.118,
    y1: -1343.9008,
    x2: -940.301,
    y2: -1357.2008,
    gradientTransform: "matrix(53.7765 0 0 18.9235 51232.7227 25753.3555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_129",
    style: {
      fill: "url(#Trazado_129_00000062898415211786780430000001306135506434348199_)"
    },
    d: "M726.5,101.5 c0.2,0.4,0.2,0.8-0.1,1.1c-4.4,5.5-10.2,9.7-16.7,12.3c-6.8,2.5-15.1,3-24,1.3c-0.9-0.2-1.9-0.4-2.8-0.6c-2-0.4-4-0.8-6-1.1 c-0.1,0-0.3,0-0.5,0c-1.3-0.1-2.9-0.1-3.4-1.2c-0.6-1.3,0.9-2.4,1.7-3l0.2-0.1c2-1.5,4.3-3.3,6.6-5c6.3-4.6,13.9-7,21.7-7 c3.7,0.2,7.5,0.6,11.1,1.3c3.7,0.7,7.4,1.1,11.1,1.3c0.1,0,0.3,0,0.4,0.1C726.1,101,726.3,101.2,726.5,101.5L726.5,101.5z  M676.4,112.5c0.3,0,0.6,0,0.7,0.1c2.1,0.3,4.2,0.7,6.2,1.1c0.9,0.2,1.9,0.4,2.8,0.5c8.4,1.6,16.2,1.1,22.7-1.2 c5.5-2.2,10.4-5.6,14.4-10c-2.7-0.2-5.9-0.7-9.1-1.2c-3.5-0.7-7.1-1.1-10.7-1.3c-7.3,0-14.4,2.3-20.3,6.6 c-2.3,1.7-4.6,3.5-6.6,5c-0.1,0-0.1,0.1-0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.3C676,112.4,676.2,112.5,676.4,112.5L676.4,112.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_130_00000069376753463385967980000006982141387734640032_",
    gradientUnits: "userSpaceOnUse",
    x1: -926.967,
    y1: -1383.2067,
    x2: -932.9269,
    y2: -1389.1337,
    gradientTransform: "matrix(37.7402 0 0 42.4575 35903.8945 59025.0742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_130",
    style: {
      fill: "url(#Trazado_130_00000069376753463385967980000006982141387734640032_)"
    },
    d: "M709.5,55.3 c0.2,2.2,5.5,6,11,10.1c10.5,7.8,24.9,18.4,23.9,30.4c0,0.3-0.2,0.6-0.5,0.8c-0.3,0.2-0.7,0.2-1,0.1c-1.4-0.5-3.1-0.9-4.9-1.3 c-6.7-1.5-15.8-3.6-23.5-14.5c-10.1-14.2-7.7-25.6-7.1-26.2c0.3-0.4,0.8-0.5,1.2-0.3c0,0,0,0,0.1,0 C709.1,54.5,709.4,54.8,709.5,55.3L709.5,55.3z M738.5,93.3c1.3,0.3,2.5,0.6,3.7,0.9c-0.2-10.4-13.4-20-23-27.2 c-4.4-3.2-8-5.9-10-8.2c-0.1,4.1,0.8,11.8,7.4,21c3.7,5.5,9.2,9.6,15.5,11.7C734.1,92.2,736.3,92.8,738.5,93.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_131_00000166665089225365665610000005466939419676082836_",
    gradientUnits: "userSpaceOnUse",
    x1: -950.9717,
    y1: -1410.4008,
    x2: -952.3147,
    y2: -1411.3297,
    gradientTransform: "matrix(167.5065 0 0 270.7559 160137.0312 382237.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_131",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_131_00000166665089225365665610000005466939419676082836_)"
    },
    d: " M790.9,79c-1.5,1.4-2.9,3-4.1,4.7c-2.9,4.1-5.2,8.9-7.9,12.8c-3.7,5.3-7.8,10.1-11.2,15.4c-2.3,3.4-4.2,7.1-5.6,10.9 c-2,5.7-3.2,11.6-3.7,17.6c-1.3,14.2,0.3,28.7-1.8,43c-3.1,20.6-11.8,39.5-22.3,55.6c-13.1,20.2-29,36.2-39.9,46.1 c-15,13.6-32.6,18.9-47.5,31.7c-8,6.9-15.1,15.9-20.7,29.6c-0.3,0.6-0.9,0.8-1.5,0.6c-0.6-0.2-0.9-0.8-0.7-1.4l0,0 c5.7-14.1,13-23.4,21.2-30.4c14.9-12.9,32.5-18.2,47.4-31.8c10.7-9.8,26.4-25.6,39.3-45.7c10.2-15.9,18.8-34.4,21.8-54.7 c2.1-14.3,0.4-28.7,1.7-42.9c0.5-6.2,1.7-12.3,3.8-18.2c1.5-4.1,3.4-7.9,5.8-11.5c3.4-5.3,7.5-10.2,11.2-15.5 c2.8-3.9,5-8.7,7.9-12.8c1.3-1.9,2.8-3.6,4.5-5.2c0.7-0.6,1.7-0.5,2.4,0.1c0.6,0.5,0.7,1.4,0.2,2C791,78.9,790.9,78.9,790.9,79 L790.9,79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_132_00000089573108552170275900000001761563505492818314_",
    gradientUnits: "userSpaceOnUse",
    x1: -893.998,
    y1: -1364.9713,
    x2: -907.476,
    y2: -1375.1044,
    gradientTransform: "matrix(16.691 0 0 24.8315 15644.2686 34361.1133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_132",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_132_00000089573108552170275900000001761563505492818314_)"
    },
    d: " M626.7,342.4c-0.6,1.7-0.3,3.8,0,5.5c0.3,2.1,0.7,4.2,1.1,6.3c0.8,3.5,2,7.1,0.3,10.4c-0.3,0.6-0.7,1.2-1.2,1.7 c-3,2.9-5.6-1.5-6.2-3.9c-0.1-0.5-0.1-2.1-0.6-2.4c-0.3-0.2-2.1,1.7-2.4,2c-2.8,2.2-5.7-0.3-5.5-3.3 C612.7,351.7,623.3,347.7,626.7,342.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_133_00000022531799033877663580000009316731870930380474_",
    gradientUnits: "userSpaceOnUse",
    x1: -901.7477,
    y1: -1368.9211,
    x2: -913.5836,
    y2: -1378.2551,
    gradientTransform: "matrix(19.0127 0 0 26.9501 17867.2363 37359.1289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_133",
    style: {
      fill: "url(#Trazado_133_00000022531799033877663580000009316731870930380474_)"
    },
    d: "M627.1,341.4 c0.5,0.2,0.8,0.8,0.6,1.3c-0.5,1.4-0.2,3.4,0,5c0.3,1.9,0.6,4.1,1.1,6.2l0.2,0.7c0.8,3.3,1.7,7,0,10.3 c-0.4,0.7-0.8,1.4-1.4,1.9c-0.9,1.1-2.4,1.5-3.8,1.1c-2.4-0.7-3.9-3.8-4.3-5.7c0-0.2-0.1-0.5-0.1-0.7c-0.2,0.2-0.3,0.3-0.4,0.4 c-0.2,0.2-0.3,0.3-0.5,0.5c-1.3,1.1-3.1,1.4-4.7,0.7c-1.8-0.9-2.9-2.9-2.7-4.9c0.3-4.6,4.5-7.8,8.5-10.9 c2.5-1.9,4.8-3.7,6.1-5.7c0.3-0.4,0.9-0.6,1.4-0.4L627.1,341.4L627.1,341.4z M616.9,361c0.1-0.1,0.2-0.2,0.4-0.4 c1.4-1.4,2.4-2.4,3.5-1.6c0.8,0.5,0.9,1.6,1,2.6c0,0.2,0,0.4,0.1,0.5c0.4,1.6,1.6,3.6,2.7,4c0.2,0,0.7,0.2,1.5-0.6 c0.4-0.4,0.8-0.9,1-1.4c1.4-2.7,0.6-5.9-0.2-9l-0.2-0.7c-0.5-2.1-0.9-4.3-1.2-6.4c-0.1-0.7-0.2-1.4-0.2-2.1 c-1.2,1.1-2.6,2.2-4.1,3.3c-3.7,2.9-7.5,5.8-7.8,9.5c-0.1,1.1,0.4,2.2,1.4,2.8c0.1,0,0.1,0.1,0.2,0.1 C615.7,361.7,616.4,361.5,616.9,361L616.9,361z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_134_00000031192048238415361160000011815616560195897732_",
    gradientUnits: "userSpaceOnUse",
    x1: -888.9537,
    y1: -1265.3701,
    x2: -903.3907,
    y2: -1295.3701,
    gradientTransform: "matrix(15.5739 0 0 8.3892 14581.7842 11069.377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_134",
    style: {
      fill: "url(#Trazado_134_00000031192048238415361160000011815616560195897732_)"
    },
    d: "M635.6,328.2 c0.1,0.5-0.3,1.1-0.8,1.1l0,0c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-1,0.6-2,1.1-3,1.7c-3,1.6-6.1,3-9.3,4.1 c-0.6,0.2-1.2-0.1-1.5-0.6c-0.2-0.5,0-1.1,0.5-1.3c0,0,0.1,0,0.1-0.1c3.1-1.1,6.1-2.4,9-3.9c1-0.5,2-1.1,3-1.6 c0.1,0,0.1-0.1,0.2-0.1c0.4-0.3,0.9-0.5,1.4-0.6c0.2,0,0.4,0,0.5,0.1C635.2,327.5,635.5,327.8,635.6,328.2L635.6,328.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_135_00000183216074430873822120000001051312934783915416_",
    gradientUnits: "userSpaceOnUse",
    x1: -883.1634,
    y1: -1323.8563,
    x2: -898.8123,
    y2: -1342.1204,
    gradientTransform: "matrix(14.3689 0 0 13.7728 13419.4248 18694.0273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_135",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_135_00000183216074430873822120000001051312934783915416_)"
    },
    d: " M626.4,332.3c-1,0.8-1.6,2.5-2.2,3.5c-1.4,2.5-3,5.2-5.5,7c-1.2,1-2.7,1.5-4.3,1.5c-1.3,0.1-2.3-0.9-2.4-2.1v-0.1 c0.1-0.8,0.5-1.6,1.1-2.2c0.4-0.4,1.1-1,1.1-1.6s-1-1.2-1.3-1.7c-0.9-1.4-1.1-3.6,0.2-4.7c2.2-1.9,5.5-1.1,8.2-0.7 C622.7,331.3,625,332.3,626.4,332.3L626.4,332.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_136_00000005251885188563440750000016432523628584931977_",
    gradientUnits: "userSpaceOnUse",
    x1: -893.5226,
    y1: -1335.9352,
    x2: -906.9945,
    y2: -1351.7762,
    gradientTransform: "matrix(16.6954 0 0 15.8726 15647.0879 21665.4434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_136",
    style: {
      fill: "url(#Trazado_136_00000005251885188563440750000016432523628584931977_)"
    },
    d: "M627.5,332 c0.2,0.4,0.1,0.9-0.3,1.2c-0.6,0.6-1.1,1.4-1.4,2.2c-0.2,0.4-0.3,0.7-0.5,1c-1.6,2.9-3.2,5.4-5.7,7.3c-1.4,1.1-3.2,1.7-5,1.7 c-1,0-2-0.5-2.7-1.2c-0.6-0.6-0.9-1.4-0.9-2.3c0.1-1,0.6-2,1.3-2.8c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.4,0.5-0.6 c-0.1-0.2-0.3-0.3-0.4-0.5c-0.3-0.2-0.5-0.5-0.7-0.8c-1.1-1.8-1.3-4.5,0.4-6c2.3-2,5.5-1.5,8-1.1c0.4,0.1,0.8,0.1,1.1,0.2 c0.8,0.1,1.6,0.4,2.3,0.6c0.8,0.3,1.7,0.5,2.6,0.6C626.8,331.3,627.2,331.5,627.5,332L627.5,332z M614.5,343.2 c1.3,0,2.5-0.4,3.5-1.3c2.2-1.6,3.7-4,5.2-6.7c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.5,0.4-0.9,0.7-1.4c-0.4-0.1-0.8-0.3-1.3-0.4 c-0.6-0.2-1.3-0.4-1.9-0.5c-0.4-0.1-0.8-0.1-1.2-0.2c-2.4-0.4-4.6-0.7-6.1,0.6c-0.8,0.7-0.7,2.4,0,3.5c0.1,0.1,0.2,0.3,0.4,0.4 c0.6,0.4,1,1.1,1.1,1.8c0,0.8-0.4,1.6-1.1,2.1c-0.1,0.1-0.2,0.2-0.2,0.2c-0.4,0.4-0.7,1-0.8,1.6c0,0.3,0.1,0.5,0.2,0.7 c0.1,0.1,0.3,0.2,0.5,0.3C614.1,343.2,614.3,343.2,614.5,343.2L614.5,343.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_137_00000123429227379444964390000002351419225897414562_",
    gradientUnits: "userSpaceOnUse",
    x1: -804.9849,
    y1: -1342.8959,
    x2: -837.2319,
    y2: -1357.4159,
    gradientTransform: "matrix(6.9772 0 0 17.3375 6374.6177 23718.7559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    style: {
      fill: "url(#Trazado_137_00000123429227379444964390000002351419225897414562_)"
    },
    d: "M654.7,309 c-0.4-0.2-0.9-0.1-1.2,0.3c-1.1,1.3-1.9,2.8-2.4,4.4l-0.2,0.5c-1.5,3.5-2.3,7.2-2.4,11c0,0.6,0.5,1.1,1.2,1.1 c0.6,0.1,1.1-0.3,1.2-0.9v-0.1c0.1-3.5,0.9-7,2.3-10.3l0.2-0.5c0.4-1.4,1-2.6,1.9-3.7c0.4-0.4,0.4-1,0-1.4l-0.1-0.1 C654.9,309.1,654.8,309,654.7,309L654.7,309z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_138_00000155136730605653020070000016373693278868913541_",
    gradientUnits: "userSpaceOnUse",
    x1: -884.0154,
    y1: -1347.6985,
    x2: -899.6265,
    y2: -1361.2845,
    gradientTransform: "matrix(14.4078 0 0 18.5195 13487.2178 25401.4707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_138_00000155136730605653020070000016373693278868913541_)"
    },
    d: " M650.8,318.3c0,0.2-1,1-1.1,1.1c-1.2,1.1-2.4,2.3-3.4,3.5c-2.6,2.9-4.4,7.7-3.4,11.7c0.1,0.4,0.3,0.8,0.5,1.2 c1.3,2.3,3.7,0.2,4.4-1.2c0.2-0.3,0.4-1.2,0.8-1.3c0.7-0.2,1.9,0.9,2.6,1c2.2,0.3,4.3-0.8,5.3-2.7 C658.5,327.1,653.1,321.9,650.8,318.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_139_00000007406703603566943060000007221188738879690406_",
    gradientUnits: "userSpaceOnUse",
    x1: -894.2628,
    y1: -1354.6254,
    x2: -907.7007,
    y2: -1366.8204,
    gradientTransform: "matrix(16.7419 0 0 20.6415 15722.1211 28404.3301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    style: {
      fill: "url(#Trazado_139_00000007406703603566943060000007221188738879690406_)"
    },
    d: "M651.8,317.8 c0.5,0.7,1.1,1.5,1.7,2.4c2.6,3.5,5.9,7.8,4,11.8c-1.3,2.4-3.9,3.7-6.5,3.3c-0.5-0.1-1-0.3-1.4-0.6c-0.2-0.1-0.4-0.2-0.6-0.3 c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2-0.1,0.3-0.2,0.4c-0.6,1.1-2.2,2.8-4,2.8c-1.1,0-2-0.7-2.5-1.6c-0.3-0.5-0.5-1-0.6-1.5 c-1.1-4.5,1-9.5,3.7-12.5c0.9-1,1.8-1.9,2.8-2.8l0.7-0.7c0,0,0.2-0.1,0.3-0.2s0.5-0.4,0.6-0.5c0.1-0.3,0.4-0.6,0.7-0.6 c0.2-0.1,0.5-0.1,0.7,0C651.4,317.4,651.6,317.6,651.8,317.8L651.8,317.8z M644.7,335.8c0.5,0,1.5-0.8,2-1.7 c0-0.1,0.1-0.1,0.1-0.2c0.2-0.7,0.7-1.3,1.4-1.6c0.9-0.1,1.8,0.1,2.5,0.7c0.2,0.1,0.4,0.2,0.7,0.3c1.7,0.2,3.3-0.7,4-2.1 c1.4-3-1.3-6.6-3.7-9.8c-0.3-0.4-0.7-0.9-1-1.3l0,0c-0.1,0.1-0.1,0.1-0.2,0.1l-0.7,0.7c-0.9,0.9-1.8,1.8-2.7,2.7 c-2.2,2.5-4.2,7-3.2,10.8c0.1,0.3,0.2,0.7,0.4,1C644.3,335.5,644.5,335.7,644.7,335.8C644.6,335.8,644.6,335.8,644.7,335.8 L644.7,335.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_140_00000066477575793656059920000003357215825339067532_",
    gradientUnits: "userSpaceOnUse",
    x1: -905.7113,
    y1: -1157.9048,
    x2: -916.6044,
    y2: -1209.3649,
    gradientTransform: "matrix(20.64 0 0 4.891 19462.6309 6090.3921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    style: {
      fill: "url(#Trazado_140_00000066477575793656059920000003357215825339067532_)"
    },
    d: "M667.6,300.7 c0.5,0.3,0.7,0.9,0.4,1.4v0.1c-0.4,0.6-1.2,0.5-2,0.4h-0.1c-1.3,0-2.5,0-3.6,0.1c-4.5,0.5-8.9,1.3-13.2,2.6 c-0.6,0.2-1.2-0.1-1.5-0.7c-0.2-0.5,0.1-1.1,0.6-1.3h0.1c4.5-1.3,9-2.2,13.6-2.7c1.2-0.1,2.4-0.1,3.8-0.1c0.1,0,0.2,0,0.3,0 s0.4,0,0.5,0c0.2-0.1,0.5-0.1,0.7,0C667.4,300.6,667.5,300.6,667.6,300.7L667.6,300.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_141_00000050648513082393002410000003659010965943694258_",
    gradientUnits: "userSpaceOnUse",
    x1: -896.5954,
    y1: -1320.7899,
    x2: -909.3724,
    y2: -1339.589,
    gradientTransform: "matrix(17.6036 0 0 13.3849 16543.4023 18113.1406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_141_00000050648513082393002410000003659010965943694258_)"
    },
    d: " M654.7,303.2c-2.5,1.8-4.6,3.9-6.9,5.8c-0.5,0.4-1,0.8-1.6,1.2c-2.1,1.4-7,3.5-8.8,0.3c-0.9-1.5,0.2-2.8,1.5-3.7 c0.5-0.4,1.3-0.6,1.5-1.2c0.2-0.8-0.3-1.4-0.6-2c-0.4-0.9-0.4-2-0.1-2.9c0.7-1.5,2.4-1.8,4.1-1.8 C647.1,298.8,651.8,301.5,654.7,303.2L654.7,303.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_142_00000065054908131221411240000017249594411524633480_",
    gradientUnits: "userSpaceOnUse",
    x1: -903.6868,
    y1: -1333.6841,
    x2: -914.9748,
    y2: -1349.9161,
    gradientTransform: "matrix(19.9263 0 0 15.5024 18767.3145 21109.8086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    style: {
      fill: "url(#Trazado_142_00000065054908131221411240000017249594411524633480_)"
    },
    d: "M655.3,302.3 c0.3,0.2,0.5,0.5,0.6,0.8c0,0.3-0.1,0.7-0.4,0.9c-1.4,1-2.7,2.2-4,3.4c-0.9,0.8-1.9,1.6-2.8,2.4c-0.6,0.5-1.2,0.9-1.7,1.2 c-0.4,0.3-4.4,2.8-7.7,2c-1.2-0.3-2.3-1.1-2.9-2.2c-0.6-1-1.1-3,1.8-5c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.6-0.3,0.6-0.5 c0-0.1,0-0.3-0.3-0.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.5-1.1-0.6-2.5-0.1-3.6c0.9-2.2,3.3-2.4,5.1-2.5c1.4,0,2.7,0.3,4,0.8 C650.3,299.6,652.9,300.8,655.3,302.3L655.3,302.3z M639.7,311.1c1.5,0.4,4-0.6,5.8-1.7c0.5-0.3,0.9-0.7,1.5-1.1 c0.9-0.8,1.9-1.6,2.8-2.4c1-0.9,1.9-1.7,3-2.6c-2.6-1.5-6.3-3.4-9-3.4c-1.8,0-2.7,0.4-3.1,1.2c-0.2,0.7-0.2,1.5,0.1,2.1 c0.1,0.2,0.1,0.3,0.2,0.5c0.5,0.7,0.6,1.5,0.4,2.3c-0.3,0.7-0.8,1.2-1.5,1.5c-0.1,0.1-0.2,0.1-0.3,0.2 c-1.8,1.2-1.3,2.1-1.2,2.4c0.2,0.4,0.6,0.8,1.1,0.9C639.6,311.1,639.7,311.1,639.7,311.1L639.7,311.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_143_00000178894262912444086110000004703355582786933393_",
    gradientUnits: "userSpaceOnUse",
    x1: -817.2816,
    y1: -1357.2256,
    x2: -847.0547,
    y2: -1368.9146,
    gradientTransform: "matrix(7.5562 0 0 21.5321 6967.3271 29631.2754)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    style: {
      fill: "url(#Trazado_143_00000178894262912444086110000004703355582786933393_)"
    },
    d: "M693.3,283.5 c-0.5-0.2-1,0-1.3,0.3c-2.8,3.5-4.6,7.7-5.1,12.1c-0.5,2.7-0.4,5.6,0.4,8.2c0.2,0.6,0.8,0.9,1.4,0.8c0.5-0.1,0.9-0.6,0.8-1.1 v-0.1c-0.7-2.4-0.8-4.9-0.3-7.3c0.5-4.1,2.1-7.9,4.7-11.1c0.3-0.4,0.3-1.1-0.2-1.4c0,0-0.1,0-0.1-0.1 C693.5,283.6,693.4,283.5,693.3,283.5L693.3,283.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_144_00000152254953129690683060000008773091880513663423_",
    gradientUnits: "userSpaceOnUse",
    x1: -896.271,
    y1: -1360.8256,
    x2: -909.335,
    y2: -1371.8346,
    gradientTransform: "matrix(17.1891 0 0 22.8551 16188.7646 31516.8105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_144_00000152254953129690683060000008773091880513663423_)"
    },
    d: " M688.4,296c0.3,0.8,0.6,1.5,1.1,2.1c0.8,1.4,1.8,2.7,2.7,4c2.1,2.9,3.5,6.3,4.2,9.8c0.4,1.4,0.5,2.8,0.3,4.2 c-0.3,1.5-2.6,3.2-4.4,2.6c-1-0.5-1.9-1.3-2.4-2.3c-0.4-0.7-0.7-1.4-0.9-2.1c-0.1-0.2-0.2-0.7-0.5-0.7 c-0.7-0.2-1.7,0.9-2.2,1.2c-1.8,1.2-4,1.5-5.4-0.5c-2.7-3.9-1-8.8,2-11.9C684.9,300.4,686.7,298.2,688.4,296L688.4,296z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_145_00000026879530821019654790000017474389815488932278_",
    gradientUnits: "userSpaceOnUse",
    x1: -903.5703,
    y1: -1365.4176,
    x2: -915.0822,
    y2: -1375.4946,
    gradientTransform: "matrix(19.5159 0 0 24.9663 18416.6621 34504.4805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    style: {
      fill: "url(#Trazado_145_00000026879530821019654790000017474389815488932278_)"
    },
    d: "M689.5,295.9 c0.2,0.5,0.4,1,0.7,1.4c0.1,0.1,0.2,0.3,0.3,0.4c0.5,0.9,1.1,1.7,1.7,2.5c0.3,0.5,0.7,1,1,1.5c2.2,3.1,3.7,6.5,4.4,10.2v0.2 c0.4,1.4,0.5,2.9,0.3,4.4c-0.4,1.3-1.3,2.4-2.6,3c-1,0.6-2.2,0.7-3.4,0.4c-1.3-0.5-2.4-1.6-3.1-2.9c-0.4-0.6-0.6-1.3-0.9-2 c-0.2,0.1-0.4,0.3-0.5,0.4c-0.2,0.1-0.3,0.3-0.5,0.3c-1.2,0.9-2.8,1.2-4.3,1c-1.1-0.2-2.1-0.9-2.8-1.9 c-3.1-4.4-1.2-9.8,2.1-13.1c1.9-2,3.7-4.1,5.3-6.2c0.3-0.4,0.7-0.5,1.2-0.4c0.1,0,0.1,0,0.2,0 C689.1,295.2,689.4,295.5,689.5,295.9L689.5,295.9z M683.2,314.6c0.9,0.1,1.8-0.2,2.5-0.7c0.1-0.1,0.2-0.1,0.3-0.2 c0.7-0.6,1.7-1.3,2.8-1.1c0.7,0.2,1.2,0.8,1.4,1.5s0.5,1.3,0.8,1.9c0.7,1.3,1.3,1.7,1.7,1.8c0.5,0.1,1,0,1.5-0.2 c0.7-0.3,1.2-0.9,1.5-1.6c0.1-1.2,0-2.5-0.3-3.7v-0.2c-0.7-3.4-2.1-6.6-4.1-9.4c-0.3-0.5-0.6-0.9-1-1.4 c-0.6-0.9-1.2-1.7-1.8-2.6l-0.2-0.4l0,0c-1.4,1.8-3.4,3.9-4.3,4.9c-2.7,2.8-4.3,7.2-1.9,10.6 C682.3,314.2,682.7,314.5,683.2,314.6C683,314.6,683.1,314.6,683.2,314.6L683.2,314.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_146_00000002359938619858980840000012391380920229757844_",
    gradientUnits: "userSpaceOnUse",
    x1: -914.1586,
    y1: -1258.8274,
    x2: -923.2747,
    y2: -1290.0844,
    gradientTransform: "matrix(24.6743 0 0 8.0508 23378.1191 10516.3174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    style: {
      fill: "url(#Trazado_146_00000002359938619858980840000012391380920229757844_)"
    },
    d: "M722,253.2 c-0.3-0.1-0.7-0.1-1,0.1c-5.6,3.3-13.3,5.4-21.8,5.8c-0.6,0-1,0.4-1,1v0.1c0.1,0.6,0.7,1,1.3,1c8.8-0.4,17-2.6,22.9-6.1 c0.5-0.3,0.6-0.9,0.4-1.3l-0.1-0.1C722.4,253.4,722.2,253.3,722,253.2L722,253.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_147_00000144314124149737248560000005475956614089712062_",
    gradientUnits: "userSpaceOnUse",
    x1: -903.8011,
    y1: -1330.0236,
    x2: -915.0651,
    y2: -1346.9976,
    gradientTransform: "matrix(19.9677 0 0 14.8241 18860.0137 20105.3945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_147_00000144314124149737248560000005475956614089712062_)"
    },
    d: " M709,258.8c-1.5,2.2-2.7,4.6-4.8,6.4c-2.4,1.9-5.2,3.1-8.3,3.3c-1.2,0.1-3,0-3.6-1.2c-0.3-0.8-0.3-1.8,0.2-2.6 c0.2-0.4,0.6-0.9,0.4-1.4c-0.3-0.8-1.5-1.4-2.1-2.1c-2-2.4-3.1-5.9,0.6-7c0.8-0.2,1.6-0.4,2.4-0.4c1.1-0.1,2.3-0.1,3.4,0 C701.4,254.3,705.1,257.5,709,258.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_148_00000133527528549361509260000001774585541421866675_",
    gradientUnits: "userSpaceOnUse",
    x1: -909.3734,
    y1: -1340.6649,
    x2: -919.4683,
    y2: -1355.5209,
    gradientTransform: "matrix(22.2798 0 0 16.9425 21073.8887 23103.2461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    style: {
      fill: "url(#Trazado_148_00000133527528549361509260000001774585541421866675_)"
    },
    d: "M704.9,255.7 c1.4,0.8,2.9,1.5,4.4,2.1c0.3,0.1,0.6,0.4,0.7,0.7c0.1,0.3,0.1,0.6-0.1,0.9c-0.4,0.6-0.8,1.2-1.2,1.8c-1,1.8-2.3,3.4-3.7,4.7 c-2.5,2.1-5.6,3.3-8.9,3.5c-2.3,0.2-4.1-0.5-4.8-1.8c-0.5-1.1-0.5-2.4,0.1-3.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.4,0.2-0.4 c-0.1-0.2-0.5-0.6-0.8-0.8c-0.4-0.3-0.7-0.6-1-0.9c-1.7-2.1-2.4-4.3-1.9-5.9c0.5-1.4,1.6-2.4,3-2.7c0.9-0.2,1.7-0.4,2.6-0.5 c1.2-0.1,2.5-0.1,3.7,0c0.9,0.1,1.7,0.3,2.6,0.6C701.6,254,703.3,254.8,704.9,255.7L704.9,255.7z M695.8,267.4 c2.8-0.2,5.4-1.3,7.6-3c1.3-1.2,2.5-2.7,3.4-4.3c0.2-0.3,0.4-0.6,0.5-0.8c-1.2-0.5-2.3-1.2-3.5-1.8c-2.2-1.2-4.4-2.4-6.7-2.7 c-1-0.1-2.1-0.1-3.2,0c-0.7,0-1.4,0.2-2.1,0.4c-0.7,0.1-1.3,0.6-1.6,1.3c-0.3,1,0.3,2.6,1.5,4.1c0.2,0.2,0.4,0.4,0.7,0.6 c0.7,0.5,1.2,1.1,1.6,1.9c0.2,0.7,0.1,1.4-0.3,1.9c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.4,1.1-0.2,1.7c0.2,0.2,0.4,0.4,0.6,0.4 C694.6,267.4,695.2,267.5,695.8,267.4L695.8,267.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_149_00000098921937690405025020000011394115820570356115_",
    gradientUnits: "userSpaceOnUse",
    x1: -940.929,
    y1: -1392.0497,
    x2: -944.2949,
    y2: -1396.4886,
    gradientTransform: "matrix(66.8094 0 0 56.6791 63608.0391 79347.4375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    style: {
      fill: "url(#Trazado_149_00000098921937690405025020000011394115820570356115_)"
    },
    d: "M581.8,244.2 c-0.3-0.1-0.5-0.2-0.8-0.2c-3.6-0.5-8.2,0.1-9.7,3.4c-0.9,2-0.3,4.2,1.7,6.2c0.3,0.3,1,1,11.1,5.4l2.3,1 c-2.9-0.4-6.7-0.8-11.8-1.4c-2.6-0.3-4.9-0.6-5.1-0.6c-2.8-0.8-5.7,0.9-6.5,3.8c0,0.1,0,0.1,0,0.2c-1,4.3,1.5,8.7,5.7,10h0.1 c3.4,1.2,6.1,0.6,18.4-2.5c-7.4,4.2-14.8,10-12.4,16.2c1.5,3.5,4.6,6.2,8.2,7.2c2.1,0.6,4.4-0.1,6-1.7c1.6-1.9,3-4,4.2-6.2 c-1.4,5.5-1.5,9.5-0.2,12c0.6,1.3,1.7,2.3,3,2.8c2.6,1,6.2,1.2,8.9-3c2.6-4,3.5-10.9,3.8-15.9c0-0.7,0.1-1.3,0.1-1.9 c2.8,7.2,7.7,17.2,13.3,19.1c0.1,0,0.1,0,0.2,0.1c2.1,0.7,4.4,0.1,6-1.5c1-0.9,1.5-2.3,1.4-3.6c-0.3-8.1-16.5-22.5-18.3-24.1 c-0.5-0.4-1.2-0.4-1.6,0c-0.4,0.4-0.4,1,0,1.4l0.1,0.1c6,5.3,17.3,16.8,17.5,22.6c0.1,0.8-0.2,1.6-0.8,2.2 c-1,1.1-2.6,1.5-4,0.9c-6.2-2.5-12.7-19.8-13.8-24.3c-0.1-1.5-0.2-1.6-0.5-1.8c-0.4-0.4-1-0.4-1.5-0.1 c-0.6,0.4-0.5,1.2-0.3,1.9v0.1c0.3,4.3,0.5,21.5-5.1,25.7c-1.3,0.9-3,1.1-4.5,0.4c-0.7-0.3-1.3-0.8-1.7-1.6 c-1.1-2.2-1.8-8.6,6.2-26.5c0.5-1.2,0.7-1.6,0-2.2c-0.4-0.3-1-0.3-1.4-0.1c-0.7,0.5-1.6,2.2-4.2,7.5c-2.5,5.2-6,12.4-8.4,14.7 c-1,1-2.4,1.4-3.8,1.1c-2.9-0.9-5.3-3-6.5-5.8c-2.4-6.2,9.3-13.5,21-18.3c0.3-0.1,1.3-0.5,0.8-1.5c-0.3-0.5-0.9-0.8-1.4-0.7 c-2.9,0.7-5.5,1.4-7.8,2c-14.1,3.6-17.1,4.4-20.1,3.3h-0.1c-3.1-1-5-4.3-4.2-7.5c0.3-1.7,2-2.9,3.7-2.5c0.1,0,0.2,0,0.3,0.1 c0.2,0,1.3,0.2,5.3,0.6c5.9,0.7,18.3,2.1,19.5,2.5c0.5,0.2,0.7,0.1,0.9,0c0.5-0.2,0.8-0.6,0.7-1.1c-0.1-0.3-0.1-0.6-0.8-0.8 l0,0l0,0c-1.4-0.5-18.6-7.9-20-9c-1.3-1.3-1.7-2.6-1.2-3.9c1-2.3,4.6-2.6,7.3-2.2c2.1,0.3,6.9,4.8,10.1,7.8 c1.5,1.5,3.1,2.9,4.8,4.1c0.5,0.3,1.2,0.2,1.6-0.3c0.3-0.5,0.2-1.1-0.3-1.4c0,0,0,0-0.1,0c-1.5-1.2-3-2.4-4.4-3.8 C588,248.3,584.4,245.1,581.8,244.2L581.8,244.2z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    className: "st74",
    d: "M0.3,408.3c40.8,29.4,99.8,18.3,128.8-24.1s23.6-110.3-11.6-147.8 c-8-8.6-18-15.9-28.9-16.6s-22.6,7.3-24.2,19.5c-2.2,17.4,17.3,30.6,32.3,26.2s25.3-19.3,33.9-33.8 c24.3-41.2,44-85.9,71.1-124.8S265,34.4,308.4,26.2s94,15.5,110.5,62.2c3.4,9.7,2.1,25-7,24.7c-9.5-0.3-10.1-16.8-5.2-25.8 c15.8-29.4,50.7-38.1,81.2-33.6s59.4,19.1,89.7,25.6c72.6,15.6,151-21.1,191.5-89.7"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    transform: "translate(226.828 82.158)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M194.9,82.7c1.7-0.3,3.4-0.5,5.1-0.5c2.2,0,4.3,0.3,6.4,0.9s3.9,1.5,5.6,2.7c1.6,1.2,2.9,2.6,3.9,4.4 c1,1.7,1.5,3.7,1.5,5.9c0,1.9-0.4,3.7-1.3,5.3c-0.9,1.6-2,2.9-3.6,4.1c-1.5,1.1-3.3,2-5.4,2.6c-2.1,0.6-4.3,0.9-6.8,0.9 c-2.8,0-5.5-0.3-8.1-0.9s-5-1.5-7.4-2.6c-2.3-1.1-4.6-2.4-6.7-3.9c-2.1-1.5-4.1-3.2-5.9-5.1c-2.6,1.2-5.3,2.1-8.1,2.8 c-2.8,0.7-5.8,1-8.8,1c-3.8,0-7-0.4-9.7-1.2c-2.7-0.8-4.9-1.9-6.5-3.2c-1.7-1.4-2.9-2.9-3.7-4.7s-1.2-3.7-1.2-5.7 c0-2.6,0.6-5,1.8-7s2.8-3.9,4.9-5.5c2-1.6,4.4-3,7.1-4.3c2.7-1.3,5.5-2.4,8.4-3.5c-0.2-1.6-0.3-3.2-0.3-4.8c0-3.6,0.7-6.9,2-9.9 c1.3-3,3.1-5.5,5.2-7.5c2.2-2.1,4.6-3.7,7.3-4.8s5.4-1.7,8.1-1.7c1.7,0,3.3,0.2,4.7,0.7s2.6,1.2,3.6,2c1,0.9,1.7,1.9,2.3,3 c0.5,1.2,0.8,2.4,0.8,3.7c0,1.8-0.4,3.5-1.1,4.9c-0.8,1.5-1.8,2.8-3.1,4s-2.9,2.3-4.6,3.3c-1.8,1-3.7,1.9-5.7,2.7 s-4.2,1.7-6.4,2.5c-2.2,0.8-4.4,1.6-6.6,2.4c0.4,2,1,4.1,1.8,6.3c0.8,2.2,1.7,4.5,2.7,6.7s2.3,4.5,3.6,6.8 c1.4,2.2,2.8,4.4,4.4,6.4c2-1.2,3.8-2.5,5.5-4.1c1.7-1.5,3.1-3.1,4.3-4.8c1.2-1.7,2.2-3.5,2.8-5.3c0.7-1.8,1-3.7,1-5.5 c0-1.4-0.1-2.5-0.4-3.4s-0.4-1.4-0.4-1.6l2.7-0.7c0.1,0.4,0.3,1.1,0.6,2.1c0.2,1,0.3,2.2,0.3,3.7c0,1.9-0.4,3.9-1.1,5.9 s-1.7,4-3,5.9s-2.8,3.7-4.6,5.4c-1.8,1.7-3.8,3.3-6,4.7c1.5,1.8,3.2,3.5,4.9,5.1s3.6,2.9,5.5,4s3.9,2,5.9,2.6s4.1,0.9,6.2,0.9 c1.8,0,3.4-0.2,5.1-0.7c1.6-0.5,3-1.2,4.3-2.1c1.2-0.9,2.2-2.1,3-3.6c0.7-1.5,1.1-3.2,1.1-5.2c0-1.8-0.4-3.4-1.1-4.7 c-0.7-1.4-1.7-2.5-3-3.4c-1.2-0.9-2.6-1.6-4.2-2.1c-1.6-0.5-3.2-0.7-4.9-0.7c-0.7,0-1.5,0-2.1,0.1c-0.7,0.1-1.3,0.2-1.9,0.3 L194.9,82.7z M156.9,67.9c-2.2,0.9-4.3,2-6.2,3.1c-2,1.1-3.6,2.3-5.1,3.7c-1.4,1.4-2.6,2.9-3.4,4.6s-1.3,3.6-1.3,5.7 c0,1.8,0.3,3.5,0.9,5s1.5,2.9,2.7,4s2.8,2,4.8,2.7c1.9,0.6,4.3,0.9,7,0.9c2.4,0,4.8-0.3,7.2-0.8s4.7-1.3,6.9-2.3 c-1.8-1.9-3.4-4-4.8-6.2c-1.4-2.2-2.7-4.4-3.8-6.7s-2.1-4.6-2.9-6.9C157.9,72.4,157.3,70.1,156.9,67.9z M187.2,46 c0-0.8-0.2-1.6-0.5-2.4c-0.3-0.8-0.8-1.5-1.5-2.2s-1.6-1.1-2.6-1.5c-1.1-0.4-2.3-0.6-3.8-0.6c-2,0-4,0.4-6,1.1 c-2,0.8-3.8,2-5.5,3.6s-3,3.7-4,6.3s-1.6,5.7-1.6,9.3c0,0.6,0,1.1,0.1,1.7c0,0.6,0.1,1.2,0.2,1.8c3.2-1.1,6.3-2.2,9.3-3.3 s5.7-2.3,8.1-3.6s4.2-2.8,5.7-4.5C186.5,50.1,187.2,48.2,187.2,46z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M33.6,86.9c-2.1-1.4-3.7-2.9-4.9-4.5c-1.2-1.6-2.1-3.2-2.7-4.8c-0.6-1.6-1-3.2-1.2-4.7s-0.2-2.9-0.2-4.2 c0-2.1,0.2-4.1,0.6-5.9c0.4-1.8,1-3.3,1.7-4.7s1.5-2.6,2.4-3.6s1.9-1.9,2.9-2.6s2-1.2,3-1.5s1.9-0.5,2.8-0.5 c1.3,0,2.5,0.4,3.7,1.1s2.1,1.7,2.9,3c0.8,1.3,1.4,2.9,1.9,4.7s0.7,3.8,0.7,6c0,2.9-0.3,5.7-0.9,8.4c-0.6,2.7-1.5,5.3-2.7,7.8 s-2.6,4.7-4.3,6.8c-1.7,2.1-3.6,3.8-5.7,5.3s-4.5,2.7-7.1,3.5s-5.3,1.2-8.3,1.2c-2.6,0-5-0.3-7.1-1C8.9,96,7,95.1,5.4,94 s-2.7-2.5-3.6-4s-1.3-3-1.3-4.6c0-1.5,0.2-2.7,0.7-3.7s1.1-1.8,1.9-2.4s1.7-1,2.8-1.3c1-0.3,2.1-0.4,3.2-0.4 c2.1,0,4,0.3,5.9,0.8s3.7,1.4,5.4,2.4s3.3,2.3,4.8,3.8c1.5,1.5,2.9,3.1,4.2,4.9l-1.3,0.9c-1.4-2-2.9-3.7-4.4-5.1 s-3.1-2.5-4.6-3.4s-3-1.5-4.5-1.8c-1.4-0.4-2.8-0.6-4-0.6s-2.3,0.1-3.2,0.4s-1.4,0.7-2,1.2s-1,1.1-1.3,1.8 c-0.3,0.7-0.4,1.5-0.4,2.3c0,1.5,0.4,3,1.2,4.3s1.9,2.5,3.2,3.4s2.9,1.7,4.7,2.3s3.6,0.8,5.5,0.8c2.3,0,4.5-0.3,6.5-0.9 s3.8-1.5,5.4-2.6s3.1-2.4,4.4-3.9s2.5-3.1,3.5-4.8s1.9-3.5,2.6-5.3c0.7-1.8,1.3-3.7,1.8-5.5s0.8-3.6,1-5.3 c0.2-1.7,0.3-3.3,0.3-4.8c0-1.9-0.2-3.6-0.5-5s-0.8-2.6-1.3-3.6s-1.2-1.7-1.9-2.2s-1.4-0.7-2.2-0.7c-1.2,0-2.3,0.4-3.5,1.3 c-1.2,0.8-2.3,2.1-3.2,3.7s-1.8,3.6-2.4,5.9s-0.9,5-0.9,7.9c0,2.2,0.2,4.1,0.6,5.9c0.4,1.7,0.9,3.2,1.6,4.5 c0.6,1.3,1.3,2.4,2.1,3.3s1.5,1.6,2.2,2.1L33.6,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M70.2,80.4c0,0.8-0.1,1.7-0.4,2.6s-0.7,1.7-1.1,2.6s-0.9,1.7-1.4,2.6c-0.5,0.8-1,1.7-1.4,2.4 c-0.4,0.8-0.8,1.5-1.1,2.2s-0.4,1.4-0.4,1.9c0,0.4,0.1,0.8,0.3,0.9c0.2,0.2,0.4,0.2,0.6,0.2c0.7,0,1.6-0.4,2.5-1.1 s1.9-1.7,2.8-2.8c0.9-1.1,1.9-2.3,2.8-3.6s1.8-2.5,2.5-3.7l1.1,0.8c-0.2,0.2-0.4,0.7-0.8,1.4s-0.9,1.5-1.5,2.4s-1.3,1.8-2,2.8 c-0.8,1-1.6,1.9-2.4,2.7c-0.9,0.8-1.7,1.5-2.7,2s-1.8,0.8-2.7,0.8c-0.5,0-1-0.1-1.4-0.3c-0.4-0.2-0.8-0.4-1.1-0.7 c-0.3-0.3-0.5-0.7-0.7-1.1s-0.3-0.9-0.3-1.3c0-0.8,0.2-1.6,0.5-2.5s0.8-1.8,1.3-2.7c0.5-0.9,1.1-1.9,1.7-2.8s1.2-1.9,1.7-2.7 c0.5-0.9,0.9-1.7,1.3-2.4c0.3-0.7,0.5-1.4,0.5-1.9c0-0.6-0.2-1.1-0.5-1.5S67.1,77,66.5,77s-1.3,0.3-2.2,0.8s-1.7,1.3-2.8,2.3 c-1,1-2.1,2.2-3.3,3.7s-2.5,3.1-3.9,5c-0.8,1.1-1.6,2.1-2.3,3.1c-0.3,0.4-0.7,0.9-1,1.3s-0.7,0.9-1,1.3s-0.6,0.9-0.9,1.3 s-0.6,0.7-0.8,1l-2.6-1.1l3.4-4.7c0.5-0.7,1-1.4,1.5-2.1c0.5-0.8,1-1.5,1.5-2.4s1-1.6,1.4-2.4s0.9-1.6,1.3-2.4 c0.6-1.2,1-2.1,1.2-2.9s0.3-1.4,0.3-1.9s-0.1-0.9-0.3-1c-0.2-0.2-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.2-1.3,0.6s-1,0.9-1.5,1.5 s-1,1.3-1.5,2c-0.5,0.8-1,1.5-1.5,2.2s-0.9,1.4-1.3,2.1s-0.8,1.2-1,1.6L46,84.9c1-1.6,1.9-3,2.7-4.3s1.6-2.4,2.3-3.4 c0.8-0.9,1.5-1.7,2.2-2.2s1.5-0.8,2.3-0.8c0.4,0,0.8,0.1,1.2,0.3c0.4,0.2,0.8,0.4,1.1,0.8c0.3,0.3,0.5,0.8,0.7,1.2 s0.3,1.1,0.3,1.7c0,0.5-0.1,1-0.2,1.6c0.9-0.8,1.7-1.5,2.4-2.1c0.7-0.5,1.4-1,2.1-1.3c0.6-0.3,1.2-0.6,1.7-0.7s1-0.2,1.4-0.2 s0.8,0.1,1.3,0.2s0.9,0.4,1.4,0.8c0.4,0.4,0.8,0.9,1.1,1.5C70,78.5,70.2,79.3,70.2,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M100.2,79.6c0.6-0.7,1.2-1.3,1.8-1.8c0.6-0.6,1.2-1.1,1.8-1.5c0.6-0.4,1.2-0.7,1.8-1 c0.6-0.2,1.2-0.3,1.7-0.3c0.4,0,0.9,0.1,1.3,0.2s0.8,0.4,1.1,0.7c0.3,0.3,0.6,0.7,0.8,1.2c0.2,0.5,0.3,1,0.3,1.7 c0,0.9-0.1,1.9-0.4,2.8s-0.6,1.8-1,2.7c-0.4,0.9-0.8,1.7-1.2,2.5s-0.9,1.6-1.2,2.3c-0.4,0.7-0.7,1.4-1,2.1s-0.4,1.3-0.4,1.8 c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,0.7,0.3c0.5,0,1.1-0.3,1.8-0.9c0.7-0.6,1.4-1.3,2.2-2.3s1.5-1.9,2.3-3s1.5-2.2,2.2-3.2 l1.1,0.8c-0.3,0.4-0.6,1-1,1.6c-0.4,0.7-0.9,1.4-1.4,2.2s-1.1,1.6-1.7,2.3c-0.6,0.8-1.3,1.5-2,2.1s-1.4,1.2-2.2,1.6 c-0.7,0.4-1.5,0.6-2.2,0.6c-0.4,0-0.8-0.1-1.2-0.2s-0.7-0.3-1-0.6s-0.5-0.6-0.7-1s-0.3-1-0.3-1.6c0-0.9,0.1-1.7,0.4-2.5 s0.7-1.6,1.1-2.4s0.9-1.6,1.5-2.4c0.5-0.8,1-1.6,1.5-2.4c0.4-0.8,0.8-1.6,1.1-2.4s0.4-1.6,0.4-2.4c0-0.4-0.1-0.7-0.2-1 c-0.2-0.2-0.4-0.4-0.9-0.4c-0.7,0-1.4,0.3-2.2,0.8s-1.6,1.3-2.4,2.2s-1.7,2-2.5,3.3c-0.9,1.2-1.7,2.5-2.6,3.9s-1.7,2.8-2.5,4.2 c-0.8,1.4-1.6,2.8-2.4,4.1L90.4,94c1-2.1,2-4,2.9-5.7s1.7-3.2,2.4-4.6c0.7-1.4,1.2-2.6,1.6-3.7s0.6-2.2,0.6-3.2 c0-0.2,0-0.4-0.1-0.6c0-0.2-0.1-0.4-0.2-0.5s-0.3-0.3-0.5-0.4s-0.4-0.2-0.7-0.2c-0.7,0-1.3,0.3-2,0.9s-1.4,1.5-2.2,2.5 s-1.6,2.3-2.4,3.7c-0.8,1.5-1.8,3-2.8,4.6c-1,1.6-2.1,3.2-3.3,4.9s-2.5,3.3-3.8,4.8l-2-1.3c0.6-0.9,1.3-1.9,2-3 c0.7-1,1.4-2.1,2.1-3.2s1.3-2.1,1.9-3.2s1.2-2.1,1.6-3s0.8-1.8,1.1-2.6c0.3-0.8,0.4-1.5,0.4-2.1c0-0.7-0.2-1.1-0.5-1.4 s-0.8-0.4-1.3-0.4c-0.6,0-1.2,0.2-1.8,0.7c-0.6,0.4-1.2,1.1-1.9,1.9c-0.7,0.8-1.4,1.8-2.1,2.9c-0.8,1.1-1.6,2.4-2.6,3.8 l-1.1-0.8c1-1.6,2-3.1,2.8-4.3c0.8-1.2,1.6-2.3,2.4-3.1c0.7-0.8,1.5-1.5,2.2-1.9s1.5-0.6,2.4-0.6c0.3,0,0.6,0,1,0.1 s0.8,0.3,1.2,0.5c0.4,0.3,0.7,0.6,1,1.1c0.3,0.4,0.5,1,0.5,1.7c1.1-1.4,2.2-2.5,3.4-3.4c1.2-0.8,2.3-1.3,3.4-1.3 c0.8,0,1.4,0.2,1.9,0.5s1,0.7,1.3,1.2s0.6,1,0.7,1.7s0.2,1.2,0.2,1.9c0,0.2,0,0.3,0,0.5C100.2,79.3,100.2,79.5,100.2,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M138.4,76.1c-0.3,0.5-0.6,1.2-1.1,2s-1,1.7-1.5,2.7s-1.1,2-1.6,3.1s-1,2.1-1.5,3.1s-0.8,2-1.1,2.9 s-0.4,1.7-0.4,2.3s0.1,1,0.4,1.2c0.2,0.2,0.6,0.3,1,0.3c0.6,0,1.1-0.2,1.7-0.5c0.6-0.3,1.2-0.8,1.8-1.3s1.1-1.1,1.7-1.8 c0.5-0.7,1.1-1.3,1.5-2c0.5-0.7,0.9-1.3,1.3-1.9c0.4-0.6,0.7-1.1,1-1.6l1.1,0.8c-0.3,0.6-0.7,1.3-1.2,2 c-0.4,0.7-0.9,1.5-1.5,2.2c-0.5,0.7-1.1,1.4-1.7,2.1c-0.6,0.7-1.3,1.3-2,1.8s-1.4,0.9-2.2,1.3s-1.5,0.5-2.3,0.5 c-1.2,0-2-0.4-2.6-1.1c-0.5-0.7-0.8-1.6-0.8-2.7c0-0.1,0-0.2,0-0.5s0-0.5,0.1-0.6c-1,1.2-1.9,2.2-2.8,3s-1.7,1.4-2.6,1.9 c-0.8,0.5-1.6,0.8-2.4,1s-1.5,0.3-2.2,0.3s-1.4-0.1-2.1-0.4c-0.7-0.2-1.2-0.6-1.7-1.1s-0.9-1-1.2-1.7c-0.3-0.7-0.4-1.5-0.4-2.4 c0-1.1,0.2-2.4,0.7-3.8s1.4-3,2.7-4.6c1.1-1.4,2.2-2.6,3.4-3.6c1.2-1,2.3-1.8,3.4-2.4s2.2-1,3.2-1.3s1.9-0.4,2.7-0.4 c1.8,0,3.2,0.3,4.1,0.9c0.9,0.6,1.5,1.5,1.7,2.7c0.4-0.5,0.8-1,1.2-1.5s0.9-1,1.3-1.5L138.4,76.1z M129.4,87.2 c0.3-0.4,0.6-0.9,0.9-1.6c0.4-0.6,0.8-1.3,1.2-2s0.8-1.3,1.2-1.9s0.7-1.2,1-1.6c0-0.2,0-0.5-0.1-0.8c0-0.4-0.2-0.8-0.4-1.2 c-0.2-0.4-0.6-0.7-1-1s-1.1-0.4-2-0.4c-0.6,0-1.3,0.1-2,0.3c-0.8,0.2-1.6,0.5-2.4,0.9s-1.7,1-2.6,1.7s-1.8,1.6-2.7,2.7 c-1.3,1.6-2.4,3.2-3.1,4.9s-1.1,3.1-1.1,4.4c0,1.1,0.3,2,0.8,2.6s1.2,0.9,2.2,0.9c1.1,0,2.1-0.2,3-0.7s1.8-1.1,2.6-1.9 s1.6-1.6,2.3-2.5C128,89,128.7,88.1,129.4,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M228.1,90.9c-0.8-0.2-1.6-0.4-2.4-0.6c-0.8-0.2-1.6-0.4-2.5-0.6c-1,2-2.1,4-3.2,6s-2.3,3.9-3.5,5.8 c-1,1.4-2,2.9-3.2,4.2c-1.2,1.4-2.4,2.7-3.8,3.9s-2.7,2.3-4.1,3.4c-1.4,1-2.8,1.9-4.3,2.7s-2.9,1.3-4.3,1.7 c-1.4,0.4-2.8,0.6-4.1,0.6c-1.2,0-2.4-0.2-3.6-0.6s-2.3-1-3.3-1.9s-1.8-1.9-2.4-3.1s-0.9-2.7-0.9-4.4c0-0.9,0.1-1.8,0.3-2.8 s0.5-2,1-3s1.1-2.1,1.8-3.2s1.7-2.2,2.7-3.3c1.4-1.5,3-2.8,4.8-3.9s3.6-2,5.6-2.7s4.1-1.2,6.2-1.6s4.4-0.5,6.6-0.5 c1.5,0,2.9,0.1,4.4,0.2s2.9,0.3,4.4,0.6c1-2.1,2-4.3,2.8-6.4s1.6-4.2,2.2-6.3c0.9-3.2,1.6-5.9,2-8.2s0.6-4.3,0.6-6 c0-1.4-0.1-2.7-0.4-3.7s-0.5-1.9-0.9-2.7s-0.8-1.3-1.3-1.8s-1-0.8-1.5-1.1s-1-0.4-1.5-0.5S221.4,51,221,51c-1.6,0-3,0.4-4.2,1.1 s-2.3,1.8-3.1,3.1s-1.5,3-1.9,4.9s-0.7,4-0.7,6.3c0,1.8,0.2,3.5,0.5,5s0.7,2.9,1.2,4.2s1,2.4,1.5,3.4s1.1,1.8,1.6,2.5 s0.9,1.2,1.2,1.5s0.5,0.5,0.5,0.5l-0.9,0.9c-1.2-1.1-2.4-2.3-3.5-3.6s-2-2.7-2.8-4.2s-1.4-3.1-1.9-4.8s-0.7-3.5-0.7-5.3 c0-2.1,0.3-4.2,0.9-6.2s1.5-3.9,2.6-5.5s2.6-2.9,4.2-3.9s3.6-1.5,5.7-1.5c0.5,0,1.1,0,1.7,0.1s1.3,0.3,2,0.6s1.4,0.7,2,1.3 s1.3,1.3,1.8,2.2s0.9,2,1.3,3.3s0.5,2.9,0.5,4.7c0,0.8,0,1.7-0.1,2.7c-0.1,1-0.2,2-0.4,3.1c-0.5,3.6-1.4,7.2-2.5,10.7 s-2.4,7-4,10.4c0.8,0.2,1.6,0.4,2.4,0.6s1.6,0.4,2.3,0.6L228.1,90.9z M192.7,116.5c1.5,0.1,3-0.2,4.6-0.8s3.2-1.6,4.8-2.8 s3.2-2.7,4.8-4.4c1.6-1.7,3.1-3.6,4.7-5.7c1.5-2.1,3-4.2,4.4-6.5s2.7-4.7,3.9-7.1c-1-0.1-2-0.2-3-0.3c-1-0.1-2-0.1-3-0.1 c-3,0-5.9,0.3-8.5,1s-4.9,1.6-7.1,2.7c-2.1,1.1-4,2.4-5.6,3.9s-3,3-4.1,4.5s-1.9,3.1-2.5,4.6s-0.8,2.9-0.8,4.2 c0,1,0.2,1.9,0.5,2.7c0.3,0.8,0.8,1.5,1.5,2.1c0.6,0.6,1.4,1.1,2.3,1.4C190.5,116.3,191.6,116.5,192.7,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M248.2,87.6c0.1,0,0.2,0,0.2,0s0.2,0,0.3,0c0.5,0,1-0.1,1.5-0.2s0.9-0.3,1.2-0.5s0.7-0.5,1.1-0.9 s0.7-0.8,1-1.4l1.1,0.8c-0.9,1.3-1.9,2.3-2.9,2.8s-2.1,0.8-3.2,0.8c-0.4,0-0.8,0-1.1-0.1c-0.8,1.4-1.7,2.6-2.7,3.6 s-1.9,1.8-2.9,2.4s-2,1.1-3,1.4s-1.9,0.4-2.7,0.4c-0.9,0-1.7-0.2-2.4-0.5s-1.4-0.7-1.9-1.3s-0.9-1.2-1.2-2s-0.4-1.7-0.4-2.6 s0.2-2,0.5-3s0.7-2,1.3-3s1.2-2,1.9-2.9s1.5-1.8,2.3-2.6s1.7-1.5,2.6-2.2s1.8-1.2,2.7-1.6l0.9,1.2c-1,0.7-2.1,1.7-3.1,2.8 c-1.1,1.1-2,2.4-2.9,3.7c-0.9,1.3-1.6,2.7-2.1,4.2s-0.8,2.9-0.8,4.2c0,1.2,0.3,2.2,0.8,2.9s1.4,1,2.5,1c0.9,0,1.7-0.2,2.5-0.5 s1.7-0.8,2.5-1.4s1.6-1.3,2.3-2.2s1.4-1.7,2.1-2.7c-0.6-0.3-1.1-0.8-1.5-1.3s-0.8-1.2-1.1-1.9s-0.5-1.5-0.7-2.3 s-0.2-1.7-0.2-2.5s0.1-1.7,0.3-2.4s0.5-1.4,0.9-2s0.8-1,1.3-1.4s1.1-0.5,1.7-0.5c0.5,0,1,0.1,1.5,0.4s0.8,0.7,1.1,1.2 s0.5,1.1,0.7,1.8s0.2,1.4,0.2,2.2c0,0.6,0,1.2-0.1,1.9s-0.2,1.4-0.4,2.1s-0.4,1.4-0.7,2.1S248.6,87.1,248.2,87.6z M244.2,80.3 c0,0.6,0,1.2,0.1,1.8s0.3,1.3,0.5,1.9s0.5,1.2,0.8,1.7s0.7,1,1.2,1.3c0.4-0.7,0.6-1.4,0.9-2.1c0.2-0.7,0.4-1.4,0.6-2.1 c0.2-0.7,0.3-1.3,0.4-1.9c0.1-0.6,0.1-1.1,0.1-1.5c0-0.6,0-1.1-0.1-1.6s-0.2-0.9-0.4-1.3s-0.4-0.6-0.6-0.8 c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4,0-0.8,0.1-1.1,0.4s-0.6,0.6-0.8,1.1s-0.4,0.9-0.5,1.5C244.3,79.1,244.2,79.7,244.2,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M278,80.4c0,0.8-0.1,1.7-0.4,2.6s-0.7,1.7-1.1,2.6s-0.9,1.7-1.4,2.6s-1,1.7-1.4,2.4s-0.8,1.5-1.1,2.2 s-0.4,1.4-0.4,1.9c0,0.4,0.1,0.8,0.3,0.9s0.4,0.2,0.6,0.2c0.7,0,1.6-0.4,2.5-1.1s1.8-1.7,2.8-2.8c0.9-1.1,1.9-2.3,2.8-3.6 s1.8-2.5,2.5-3.7l1.1,0.8c-0.2,0.2-0.4,0.7-0.8,1.4s-0.9,1.5-1.5,2.4s-1.3,1.8-2,2.8c-0.8,1-1.6,1.9-2.4,2.7s-1.7,1.5-2.7,2 s-1.8,0.8-2.7,0.8c-0.5,0-1-0.1-1.4-0.3s-0.8-0.4-1.1-0.7c-0.3-0.3-0.5-0.7-0.7-1.1S269,94.5,269,94c0-0.8,0.2-1.6,0.5-2.5 s0.8-1.8,1.3-2.7s1.1-1.9,1.7-2.8s1.2-1.9,1.7-2.7s0.9-1.7,1.3-2.4c0.3-0.7,0.5-1.4,0.5-1.9c0-0.6-0.2-1.1-0.5-1.5 s-0.8-0.6-1.4-0.6s-1.3,0.3-2.2,0.8s-1.7,1.3-2.8,2.3s-2.1,2.2-3.3,3.7s-2.5,3.1-3.9,5c-0.8,1.1-1.6,2.1-2.3,3.1 c-0.3,0.4-0.7,0.9-1,1.3s-0.7,0.9-1,1.3s-0.6,0.9-0.9,1.3s-0.6,0.7-0.8,1l-2.6-1.1l3.4-4.7c0.5-0.7,1-1.4,1.5-2.1s1-1.5,1.5-2.4 s1-1.6,1.4-2.4s0.9-1.6,1.3-2.4c0.6-1.2,1-2.1,1.2-2.9s0.3-1.4,0.3-1.9s-0.1-0.9-0.3-1s-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.2-1.3,0.6 s-1,0.9-1.5,1.5s-1,1.3-1.5,2c-0.5,0.8-1,1.5-1.5,2.2s-0.9,1.4-1.3,2.1s-0.8,1.2-1,1.6l-1.1-0.8c1-1.6,1.9-3,2.7-4.3 c0.8-1.3,1.6-2.4,2.3-3.4c0.8-0.9,1.5-1.7,2.2-2.2s1.5-0.8,2.3-0.8c0.4,0,0.8,0.1,1.2,0.3c0.4,0.2,0.8,0.4,1.1,0.8 c0.3,0.3,0.5,0.8,0.7,1.2s0.3,1.1,0.3,1.7c0,0.5-0.1,1-0.2,1.6c0.9-0.8,1.7-1.5,2.4-2.1s1.4-1,2.1-1.3s1.2-0.6,1.7-0.7 s1-0.2,1.4-0.2s0.8,0.1,1.3,0.2s0.9,0.4,1.4,0.8s0.8,0.9,1.1,1.5C277.9,78.5,278,79.3,278,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M296.6,89c-0.8,0.8-1.5,1.6-2.3,2.3s-1.6,1.3-2.3,1.9s-1.5,0.9-2.2,1.2s-1.4,0.5-2.1,0.5 c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.6-1.2s-0.8-1.2-1-1.9s-0.4-1.5-0.4-2.4c0-1.2,0.2-2.4,0.7-3.7s1.1-2.5,1.9-3.7 s1.6-2.3,2.6-3.4c0.9-1.1,1.9-2,2.8-2.8l1.3,0.9c-0.2,0.3-0.6,0.8-1,1.4s-0.8,1.3-1.3,2s-0.9,1.6-1.4,2.5s-0.9,1.8-1.3,2.8 s-0.7,1.9-1,2.8c-0.2,0.9-0.4,1.8-0.4,2.6c0,0.4,0,0.8,0.1,1.1c0.1,0.4,0.2,0.7,0.4,1c0.2,0.3,0.4,0.5,0.7,0.6s0.6,0.2,1.1,0.2 c0.7,0,1.4-0.2,2.2-0.6c0.8-0.4,1.7-1,2.5-1.7c0.9-0.7,1.8-1.6,2.7-2.6s1.8-2,2.7-3.1s1.7-2.3,2.5-3.4s1.6-2.3,2.3-3.5 c0.6-1,1.2-2.1,1.9-3.1s1.2-2.1,1.9-3.1l1.4,0.7c0,0-0.2,0.4-0.5,1.1s-0.8,1.6-1.4,2.8s-1.2,2.5-2,4.1s-1.5,3.2-2.4,5 s-1.7,3.5-2.6,5.4c-0.9,1.8-1.7,3.6-2.5,5.4c2.8-1.5,5.2-3.3,7.5-5.4c2.2-2.1,4.2-4.3,5.8-6.6l1.1,0.8c-1.7,2.6-3.8,5-6.3,7.2 S299,97,295.5,99c-1.6,3.5-3.2,6.7-4.8,9.5s-3.1,5.3-4.7,7.4s-3.1,3.6-4.7,4.8s-3.1,1.7-4.7,1.7c-1.1,0-1.9-0.4-2.6-1.1 s-1.1-1.7-1.1-3c0-1.1,0.2-2.2,0.7-3.4s1.2-2.3,2-3.5s1.9-2.3,3.1-3.5c1.2-1.1,2.5-2.2,3.9-3.3s2.9-2.1,4.4-3 c1.5-1,3.1-1.8,4.7-2.6c0.4-0.9,0.8-1.8,1.3-2.7s0.9-1.9,1.4-2.8s0.9-1.7,1.3-2.5C296,90.2,296.3,89.6,296.6,89z M290.2,101.8 c-2.2,1.4-4.3,2.9-6.3,4.4s-3.6,3.1-5,4.7c-1.4,1.5-2.5,3-3.3,4.3s-1.2,2.5-1.2,3.4c0,0.6,0.2,1.1,0.5,1.5 c0.4,0.4,0.8,0.6,1.4,0.6c0.8,0,1.5-0.3,2.4-0.8c0.8-0.5,1.6-1.2,2.4-2.1s1.6-2,2.4-3.2s1.6-2.5,2.4-3.9s1.5-2.9,2.2-4.4 S289.5,103.3,290.2,101.8z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    transform: "translate(17.86 58.939)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M7.8,17.4c-0.9-0.6-1.6-1.3-2.1-2c-0.5-0.7-0.9-1.4-1.2-2.1c-0.3-0.7-0.4-1.4-0.5-2 C3.9,10.6,3.9,10,3.9,9.5c0-0.9,0.1-1.8,0.3-2.6c0.2-0.8,0.4-1.5,0.7-2.1c0.3-0.6,0.7-1.1,1-1.6c0.4-0.5,0.8-0.8,1.2-1.1 C7.6,1.9,8,1.6,8.4,1.5c0.4-0.1,0.9-0.2,1.2-0.2c0.6,0,1.1,0.2,1.6,0.5s0.9,0.8,1.3,1.3c0.4,0.6,0.6,1.2,0.8,2s0.3,1.7,0.3,2.6 c0,1.3-0.1,2.5-0.4,3.7c-0.3,1.2-0.7,2.3-1.2,3.4s-1.1,2.1-1.9,3c-0.7,0.9-1.6,1.7-2.5,2.3c-0.9,0.7-2,1.2-3.1,1.5 c-1.1,0.4-2.3,0.5-3.6,0.5c-1.1,0-2.2-0.1-3.1-0.4c-1-0.3-1.8-0.7-2.5-1.2s-1.2-1.1-1.6-1.7c-0.4-0.6-0.6-1.3-0.6-2 c0-0.6,0.1-1.2,0.3-1.6c0.2-0.4,0.5-0.8,0.9-1c0.4-0.3,0.8-0.5,1.2-0.6c0.5-0.1,0.9-0.2,1.4-0.2c0.9,0,1.8,0.1,2.6,0.4 c0.8,0.2,1.6,0.6,2.4,1c0.8,0.5,1.5,1,2.1,1.6c0.7,0.6,1.3,1.4,1.8,2.1l-0.6,0.4c-0.6-0.9-1.3-1.6-1.9-2.2 c-0.7-0.6-1.3-1.1-2-1.5S0,14.6-0.6,14.4s-1.2-0.2-1.7-0.2s-1,0.1-1.4,0.2c-0.4,0.1-0.7,0.3-1,0.5s-0.4,0.5-0.6,0.8 c-0.1,0.3-0.2,0.7-0.2,1c0,0.7,0.2,1.3,0.5,1.9s0.8,1.1,1.4,1.5s1.3,0.8,2,1c0.8,0.2,1.6,0.4,2.4,0.4c1,0,2-0.1,2.8-0.4 C4.5,20.8,5.3,20.5,6,20s1.4-1,1.9-1.7C8.5,17.7,9,17,9.4,16.2c0.4-0.7,0.8-1.5,1.1-2.3s0.6-1.6,0.8-2.4s0.4-1.6,0.5-2.3 c0.1-0.8,0.1-1.5,0.1-2.1c0-0.8-0.1-1.6-0.2-2.2c-0.1-0.6-0.3-1.2-0.6-1.6c-0.2-0.4-0.5-0.7-0.8-1c0-0.2-0.3-0.4-0.6-0.4 c-0.5,0-1,0.2-1.5,0.6s-1,0.9-1.4,1.6C6.3,4.8,6,5.7,5.7,6.7s-0.4,2.2-0.4,3.5c0,1,0.1,1.8,0.3,2.6c0.2,0.8,0.4,1.4,0.7,2 c0.3,0.6,0.6,1,0.9,1.4c0.3,0.4,0.6,0.7,1,0.9L7.8,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M23.7,14.6c0,0.4-0.1,0.7-0.2,1.1s-0.3,0.8-0.5,1.1c-0.2,0.4-0.4,0.8-0.6,1.1c-0.2,0.4-0.4,0.7-0.6,1.1 c-0.2,0.3-0.4,0.7-0.5,1s-0.2,0.6-0.2,0.9c0,0.2,0,0.3,0.1,0.4s0.2,0.1,0.3,0.1c0.3,0,0.7-0.2,1.1-0.5s0.8-0.7,1.2-1.2 c0.4-0.5,0.8-1,1.2-1.6c0.4-0.6,0.8-1.1,1.1-1.6l0.5,0.4c-0.1,0.1-0.2,0.3-0.4,0.6c-0.2,0.3-0.4,0.6-0.7,1 c-0.3,0.4-0.6,0.8-0.9,1.2c-0.3,0.4-0.7,0.8-1.1,1.2c-0.4,0.4-0.8,0.6-1.2,0.9c-0.4,0.2-0.8,0.3-1.2,0.3c-0.2,0-0.4,0-0.6-0.1 s-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.3-0.3-0.5c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.3,0.1-0.7,0.2-1.1s0.3-0.8,0.6-1.2 c0.2-0.4,0.5-0.8,0.7-1.2c0.3-0.4,0.5-0.8,0.7-1.2c0.2-0.4,0.4-0.7,0.6-1c0.1-0.3,0.2-0.6,0.2-0.8c0-0.3-0.1-0.5-0.2-0.7 c0-0.3-0.2-0.4-0.4-0.4c-0.3,0-0.6,0.1-0.9,0.3c-0.4,0.2-0.8,0.6-1.2,1c-0.4,0.4-0.9,1-1.5,1.6c-0.5,0.6-1.1,1.4-1.7,2.2 c-0.4,0.5-0.7,0.9-1,1.4c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.3-0.3,0.5 l-1.1-0.5l1.5-2.1c0.2-0.3,0.4-0.6,0.7-0.9c0.2-0.3,0.4-0.7,0.7-1c0.2-0.4,0.4-0.7,0.6-1.1c0.2-0.4,0.4-0.7,0.6-1 c0.2-0.5,0.4-0.9,0.5-1.3c0.1-0.3,0.1-0.6,0.1-0.8s0-0.4-0.1-0.5s-0.2-0.1-0.4-0.1c-0.2,0-0.3,0.1-0.6,0.2 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.3-0.4,0.6-0.7,0.9c-0.2,0.3-0.4,0.7-0.6,1c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.3,0.5-0.4,0.7 L13,16.4c0.4-0.7,0.8-1.3,1.2-1.9c0.4-0.6,0.7-1.1,1-1.5s0.6-0.7,1-1c0.3-0.2,0.6-0.3,1-0.3c0.2,0,0.4,0,0.5,0.1 c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.5,0.1,0.7s0,0.5-0.1,0.7c0.4-0.4,0.7-0.7,1-0.9s0.6-0.4,0.9-0.6 c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.4-0.1,0.6-0.1s0.3,0,0.6,0.1c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.2,0.3,0.4,0.5,0.7 C23.7,13.8,23.7,14.1,23.7,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M36.8,14.3c0.2-0.3,0.5-0.6,0.8-0.8s0.5-0.5,0.8-0.6c0.3-0.2,0.5-0.3,0.8-0.4c0.3-0.1,0.5-0.1,0.7-0.1 s0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7c0,0.4-0.1,0.8-0.2,1.2 c-0.1,0.4-0.3,0.8-0.4,1.2c-0.2,0.4-0.4,0.7-0.5,1.1c-0.2,0.4-0.4,0.7-0.5,1c-0.2,0.3-0.3,0.6-0.4,0.9c-0.1,0.3-0.2,0.5-0.2,0.8 c0,0.2,0,0.3,0.1,0.4s0.2,0.1,0.3,0.1c0.2,0,0.5-0.1,0.8-0.4s0.6-0.6,1-1c0.3-0.4,0.7-0.8,1-1.3s0.7-1,1-1.4l0.5,0.4 c-0.1,0.2-0.3,0.4-0.4,0.7c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.5,0.7-0.8,1s-0.6,0.7-0.9,0.9c-0.3,0.3-0.6,0.5-0.9,0.7 c-0.3,0.2-0.6,0.3-1,0.3c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.3-0.5S38,20.3,38,20 c0-0.4,0.1-0.7,0.2-1.1c0.1-0.4,0.3-0.7,0.5-1.1s0.4-0.7,0.6-1c0.2-0.3,0.4-0.7,0.6-1c0.2-0.3,0.4-0.7,0.5-1s0.2-0.7,0.2-1.1 c0-0.2,0-0.3-0.1-0.4C40.3,13,40.2,13,40,13c-0.3,0-0.6,0.1-0.9,0.4c-0.3,0.2-0.7,0.6-1,1c-0.4,0.4-0.7,0.9-1.1,1.4 c-0.4,0.5-0.7,1.1-1.1,1.7c-0.4,0.6-0.7,1.2-1.1,1.8c-0.4,0.6-0.7,1.2-1,1.8l-1.1-0.6c0.5-0.9,0.9-1.8,1.3-2.5 c0.4-0.7,0.7-1.4,1-2c0.3-0.6,0.5-1.1,0.7-1.6s0.3-1,0.3-1.4c0-0.1,0-0.2,0-0.3s-0.1-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0-0.6,0.1-0.9,0.4c-0.3,0.3-0.6,0.6-0.9,1.1c-0.3,0.5-0.7,1-1.1,1.6c-0.4,0.6-0.8,1.3-1.2,2 c-0.4,0.7-0.9,1.4-1.4,2.1s-1.1,1.4-1.7,2.1L27.1,21c0.3-0.4,0.6-0.8,0.9-1.3s0.6-0.9,0.9-1.4s0.6-0.9,0.8-1.4 c0.3-0.5,0.5-0.9,0.7-1.3c0.2-0.4,0.4-0.8,0.5-1.2s0.2-0.6,0.2-0.9c0-0.3-0.1-0.5-0.2-0.6s-0.3-0.2-0.6-0.2 c-0.3,0-0.5,0.1-0.8,0.3s-0.5,0.5-0.8,0.8c-0.3,0.4-0.6,0.8-0.9,1.3s-0.7,1-1.1,1.6l-0.5-0.4c0.5-0.7,0.9-1.3,1.2-1.9 c0.4-0.5,0.7-1,1-1.4s0.6-0.6,1-0.8c0.3-0.2,0.7-0.3,1-0.3c0.1,0,0.3,0,0.4,0.1c0.2,0,0.3,0.1,0.5,0.2c0.2,0.1,0.3,0.3,0.5,0.5 c0.1,0.2,0.2,0.4,0.2,0.8c0.5-0.6,1-1.1,1.5-1.5s1-0.6,1.5-0.6c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.3,0.6,0.5 c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.3,0.1,0.5,0.1,0.8c0,0.1,0,0.1,0,0.2C36.8,14.1,36.8,14.2,36.8,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M53.5,12.7c-0.1,0.2-0.3,0.5-0.5,0.9s-0.4,0.8-0.6,1.2c-0.2,0.4-0.5,0.9-0.7,1.4c-0.2,0.5-0.4,0.9-0.6,1.4 c-0.2,0.4-0.4,0.9-0.5,1.3s-0.2,0.7-0.2,1s0.1,0.5,0.2,0.5c0.1,0.1,0.2,0.1,0.4,0.1s0.5-0.1,0.8-0.2s0.5-0.3,0.8-0.6 c0.3-0.2,0.5-0.5,0.7-0.8s0.5-0.6,0.7-0.9s0.4-0.6,0.6-0.8c0.2-0.3,0.3-0.5,0.4-0.7l0.5,0.4c-0.1,0.3-0.3,0.6-0.5,0.9 s-0.4,0.6-0.6,1c-0.2,0.3-0.5,0.6-0.8,0.9s-0.6,0.6-0.9,0.8c-0.3,0.2-0.6,0.4-1,0.6c-0.3,0.1-0.7,0.2-1,0.2 c-0.5,0-0.9-0.2-1.1-0.5c-0.2-0.3-0.4-0.7-0.4-1.2c0,0,0-0.1,0-0.2s0-0.2,0-0.3c-0.4,0.5-0.8,1-1.2,1.3c-0.4,0.4-0.8,0.6-1.1,0.8 c-0.4,0.2-0.7,0.3-1,0.4s-0.7,0.1-1,0.1s-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.8s-0.2-0.6-0.2-1 c0-0.5,0.1-1,0.3-1.7c0.2-0.6,0.6-1.3,1.2-2c0.5-0.6,1-1.1,1.5-1.6c0.5-0.4,1-0.8,1.5-1c0.5-0.3,1-0.4,1.4-0.6 c0.4-0.1,0.8-0.2,1.2-0.2c0.8,0,1.4,0.1,1.8,0.4c0.4,0.3,0.6,0.7,0.7,1.2c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.4-0.4,0.6-0.7 L53.5,12.7z M49.6,17.6c0.1-0.2,0.2-0.4,0.4-0.7c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.4-0.6,0.5-0.9c0.2-0.3,0.3-0.5,0.4-0.7 c0-0.1,0-0.2,0-0.4s-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.3-0.4-0.5c-0.2-0.1-0.5-0.2-0.9-0.2c-0.3,0-0.6,0-0.9,0.1 c-0.3,0.1-0.7,0.2-1,0.4c-0.4,0.2-0.8,0.4-1.1,0.8c-0.4,0.3-0.8,0.7-1.2,1.2c-0.6,0.7-1,1.4-1.4,2.1c-0.3,0.7-0.5,1.4-0.5,1.9 s0.1,0.9,0.3,1.1c0.2,0.3,0.5,0.4,0.9,0.4c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.5,1.2-0.8s0.7-0.7,1-1.1 C49,18.4,49.3,18,49.6,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M77.9,17.4c0.4-0.1,0.8-0.1,1.2-0.1c0.5,0,1,0.1,1.5,0.2c0.5,0.2,1,0.4,1.4,0.7c0.4,0.3,0.7,0.6,1,1.1 c0.2,0.4,0.4,0.9,0.4,1.4s-0.1,0.9-0.3,1.3c-0.2,0.4-0.5,0.7-0.9,1s-0.8,0.5-1.3,0.6s-1,0.2-1.6,0.2c-0.7,0-1.3-0.1-2-0.2 c-0.6-0.1-1.2-0.4-1.8-0.6c-0.6-0.3-1.1-0.6-1.6-1s-1-0.8-1.4-1.2c-0.6,0.3-1.3,0.5-2,0.7s-1.4,0.2-2.1,0.2 c-0.9,0-1.7-0.1-2.3-0.3c-0.6-0.2-1.2-0.5-1.6-0.8s-0.7-0.7-0.9-1.1s-0.3-0.9-0.3-1.4c0-0.6,0.1-1.2,0.4-1.7 c0.3-0.5,0.7-0.9,1.2-1.3c0.5-0.4,1.1-0.7,1.7-1s1.3-0.6,2-0.9c-0.1-0.4-0.1-0.8-0.1-1.2c0-0.9,0.2-1.7,0.5-2.4s0.7-1.3,1.3-1.8 c0.5-0.5,1.1-0.9,1.8-1.2c0.7-0.3,1.3-0.4,2-0.4c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.7 c0.1,0.3,0.2,0.6,0.2,0.9c0,0.4-0.1,0.8-0.3,1.2c-0.2,0.4-0.4,0.7-0.8,1c-0.3,0.3-0.7,0.6-1.1,0.8s-0.9,0.5-1.4,0.7 s-1,0.4-1.6,0.6c-0.5,0.2-1.1,0.4-1.6,0.6c0.1,0.5,0.2,1,0.4,1.5c0.2,0.5,0.4,1.1,0.7,1.6c0.3,0.6,0.5,1.1,0.9,1.6 c0.3,0.5,0.7,1.1,1.1,1.6c0.5-0.3,0.9-0.6,1.3-1s0.8-0.8,1-1.2c0.3-0.4,0.5-0.8,0.7-1.3c0.2-0.4,0.2-0.9,0.2-1.3 c0-0.3,0-0.6-0.1-0.8s-0.1-0.3-0.1-0.4l0.7-0.2c0,0.1,0.1,0.3,0.1,0.5c0.1,0.2,0.1,0.5,0.1,0.9c0,0.5-0.1,0.9-0.3,1.4 c-0.2,0.5-0.4,1-0.7,1.4c-0.3,0.5-0.7,0.9-1.1,1.3s-0.9,0.8-1.5,1.1c0.4,0.4,0.8,0.9,1.2,1.2c0.4,0.4,0.9,0.7,1.3,1 c0.5,0.3,0.9,0.5,1.4,0.6c0.5,0.2,1,0.2,1.5,0.2c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.3,1-0.5s0.5-0.5,0.7-0.9s0.3-0.8,0.3-1.3 c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.4-0.6-0.7-0.8c-0.3-0.2-0.6-0.4-1-0.5s-0.8-0.2-1.2-0.2c-0.2,0-0.4,0-0.5,0 c-0.2,0-0.3,0-0.5,0.1L77.9,17.4z M68.6,13.8c-0.5,0.2-1,0.5-1.5,0.7c-0.5,0.3-0.9,0.6-1.2,0.9c-0.4,0.3-0.6,0.7-0.8,1.1 c-0.2,0.4-0.3,0.9-0.3,1.4c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.4,0.7,0.7,1c0.3,0.3,0.7,0.5,1.2,0.6c0.5,0.2,1,0.2,1.7,0.2 c0.6,0,1.2-0.1,1.7-0.2c0.6-0.1,1.1-0.3,1.7-0.6c-0.4-0.5-0.8-1-1.2-1.5c-0.4-0.5-0.7-1.1-0.9-1.6c-0.3-0.6-0.5-1.1-0.7-1.7 C68.9,14.9,68.7,14.3,68.6,13.8z M76,8.5c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.2-0.4-0.3-0.6-0.4 c-0.3-0.1-0.6-0.1-0.9-0.1c-0.5,0-1,0.1-1.5,0.3C72,7.3,71.6,7.6,71.2,8c-0.4,0.4-0.7,0.9-1,1.5s-0.4,1.4-0.4,2.3 c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0.1,0.4c0.8-0.3,1.5-0.5,2.3-0.8c0.7-0.3,1.4-0.6,2-0.9c0.6-0.3,1-0.7,1.4-1.1 C75.8,9.5,76,9,76,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M107.1,19.2c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4-0.1-0.7-0.2-1.1-0.2c-0.4,0.9-0.9,1.8-1.4,2.6 c-0.5,0.9-1,1.7-1.5,2.5c-0.4,0.6-0.9,1.3-1.4,1.9s-1.1,1.2-1.6,1.7c-0.6,0.5-1.2,1-1.8,1.5c-0.6,0.4-1.2,0.8-1.9,1.2 c-0.6,0.3-1.3,0.6-1.9,0.8c-0.6,0.2-1.2,0.3-1.8,0.3c-0.5,0-1-0.1-1.6-0.3c-0.5-0.2-1-0.5-1.4-0.8c-0.4-0.4-0.8-0.8-1-1.4 c-0.3-0.6-0.4-1.2-0.4-1.9c0-0.4,0-0.8,0.1-1.2c0.1-0.4,0.2-0.9,0.4-1.3c0.2-0.5,0.5-0.9,0.8-1.4s0.7-1,1.2-1.5 c0.6-0.7,1.3-1.2,2.1-1.7c0.8-0.5,1.6-0.9,2.5-1.2c0.9-0.3,1.8-0.5,2.7-0.7c0.9-0.1,1.9-0.2,2.9-0.2c0.6,0,1.3,0,1.9,0.1 s1.3,0.1,1.9,0.3c0.5-0.9,0.9-1.9,1.2-2.8c0.4-0.9,0.7-1.8,1-2.8c0.4-1.4,0.7-2.6,0.9-3.6c0.2-1,0.3-1.9,0.3-2.6 c0-0.6-0.1-1.2-0.2-1.6c-0.1-0.5-0.2-0.8-0.4-1.2c-0.2-0.3-0.4-0.6-0.6-0.8c-0.2-0.2-0.4-0.4-0.6-0.5c-0.2-0.1-0.4-0.2-0.6-0.2 s-0.4-0.1-0.6-0.1c-0.7,0-1.3,0.2-1.8,0.5s-1,0.8-1.4,1.4S100.2,5,100,5.8c-0.2,0.8-0.3,1.8-0.3,2.8c0,0.8,0.1,1.5,0.2,2.2 s0.3,1.3,0.5,1.8c0.2,0.6,0.4,1,0.7,1.5c0.2,0.4,0.5,0.8,0.7,1.1s0.4,0.5,0.5,0.7c0.1,0.2,0.2,0.2,0.2,0.2l-0.4,0.4 c-0.5-0.5-1.1-1-1.5-1.6c-0.5-0.6-0.9-1.2-1.2-1.8c-0.4-0.7-0.6-1.4-0.8-2.1c-0.2-0.7-0.3-1.5-0.3-2.3c0-0.9,0.1-1.8,0.4-2.7 s0.6-1.7,1.2-2.4c0.5-0.7,1.1-1.3,1.9-1.7c0.7-0.4,1.6-0.7,2.5-0.7c0.2,0,0.5,0,0.7,0.1c0.3,0,0.6,0.1,0.9,0.3 c0.3,0.1,0.6,0.3,0.9,0.6c0.3,0.2,0.6,0.6,0.8,1c0.2,0.4,0.4,0.9,0.6,1.5c0.1,0.6,0.2,1.3,0.2,2.1c0,0.4,0,0.8-0.1,1.2 c0,0.4-0.1,0.9-0.2,1.3c-0.2,1.6-0.6,3.1-1.1,4.7c-0.5,1.5-1.1,3-1.8,4.5c0.4,0.1,0.7,0.2,1,0.2c0.3,0.1,0.7,0.2,1,0.3 L107.1,19.2z M91.6,30.3c0.6,0,1.3-0.1,2-0.4s1.4-0.7,2.1-1.2s1.4-1.2,2.1-1.9c0.7-0.8,1.4-1.6,2-2.5c0.7-0.9,1.3-1.8,1.9-2.9 c0.6-1,1.2-2,1.7-3.1c-0.4-0.1-0.9-0.1-1.3-0.1s-0.9-0.1-1.3-0.1c-1.3,0-2.6,0.1-3.7,0.4C96,19,94.9,19.4,94,19.8 c-0.9,0.5-1.7,1.1-2.5,1.7c-0.7,0.6-1.3,1.3-1.8,2s-0.8,1.4-1.1,2c-0.2,0.7-0.4,1.3-0.4,1.8c0,0.4,0.1,0.8,0.2,1.2 c0.1,0.4,0.4,0.7,0.6,0.9c0.3,0.3,0.6,0.5,1,0.6C90.6,30.3,91.1,30.3,91.6,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M115.8,17.7L115.8,17.7h0.2c0.2,0,0.5,0,0.7-0.1c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.5-0.4 c0.2-0.2,0.3-0.4,0.4-0.6l0.5,0.4c-0.4,0.6-0.8,1-1.3,1.2c-0.4,0.2-0.9,0.3-1.4,0.3c-0.2,0-0.3,0-0.5-0.1 c-0.4,0.6-0.8,1.1-1.2,1.6c-0.4,0.4-0.8,0.8-1.3,1.1c-0.4,0.3-0.9,0.5-1.3,0.6s-0.8,0.2-1.2,0.2c-0.4,0-0.7-0.1-1-0.2 s-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.9s-0.2-0.7-0.2-1.2s0.1-0.9,0.2-1.3s0.3-0.9,0.6-1.3c0.2-0.4,0.5-0.9,0.8-1.3 c0.3-0.4,0.7-0.8,1-1.1c0.4-0.4,0.7-0.7,1.1-0.9c0.4-0.3,0.8-0.5,1.2-0.7l0.4,0.5c-0.5,0.3-0.9,0.7-1.4,1.2s-0.9,1-1.3,1.6 s-0.7,1.2-0.9,1.8c-0.2,0.6-0.4,1.3-0.4,1.8s0.1,1,0.4,1.2c0.2,0.3,0.6,0.4,1.1,0.4c0.4,0,0.7-0.1,1.1-0.2 c0.4-0.2,0.7-0.4,1.1-0.6c0.3-0.3,0.7-0.6,1-0.9c0.3-0.4,0.6-0.7,0.9-1.2c-0.2-0.1-0.5-0.3-0.7-0.6c-0.2-0.2-0.3-0.5-0.5-0.8 c-0.1-0.3-0.2-0.6-0.3-1c-0.1-0.4-0.1-0.7-0.1-1.1c0-0.4,0-0.7,0.1-1.1c0.1-0.3,0.2-0.6,0.4-0.9c0.2-0.3,0.4-0.5,0.6-0.6 s0.5-0.2,0.7-0.2s0.5,0.1,0.6,0.2c0.2,0.1,0.3,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.3,0.8c0.1,0.3,0.1,0.6,0.1,1c0,0.3,0,0.5-0.1,0.8 c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.2,0.6-0.3,0.9C116.1,17.2,116,17.5,115.8,17.7z M114.1,14.5c0,0.2,0,0.5,0.1,0.8 c0,0.3,0.1,0.6,0.2,0.8c0.1,0.3,0.2,0.5,0.4,0.8c0.1,0.2,0.3,0.4,0.5,0.6c0.2-0.3,0.3-0.6,0.4-0.9s0.2-0.6,0.3-0.9 c0.1-0.3,0.1-0.6,0.2-0.8c0-0.3,0-0.5,0-0.7c0-0.3,0-0.5-0.1-0.7c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.2-0.3-0.3-0.4 c-0.1-0.1-0.2-0.1-0.4-0.1c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0.1-0.3,0.3-0.4,0.5s-0.2,0.4-0.2,0.7C114.1,14,114.1,14.3,114.1,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M128.9,14.6c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.4-0.3,0.8-0.5,1.1c-0.2,0.4-0.4,0.8-0.6,1.1 c-0.2,0.4-0.4,0.7-0.6,1.1c-0.2,0.3-0.4,0.7-0.5,1s-0.2,0.6-0.2,0.9c0,0.2,0,0.3,0.1,0.4s0.2,0.1,0.3,0.1c0.3,0,0.7-0.2,1.1-0.5 c0.4-0.3,0.8-0.7,1.2-1.2s0.8-1,1.2-1.6s0.8-1.1,1.1-1.6l0.5,0.4c-0.1,0.1-0.2,0.3-0.4,0.6c-0.2,0.3-0.4,0.6-0.7,1 s-0.6,0.8-0.9,1.2c-0.3,0.4-0.7,0.8-1.1,1.2c-0.4,0.4-0.8,0.6-1.2,0.9c-0.4,0.2-0.8,0.3-1.2,0.3c-0.2,0-0.4,0-0.6-0.1 s-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.3-0.3-0.5s-0.1-0.4-0.1-0.6c0-0.3,0.1-0.7,0.2-1.1s0.3-0.8,0.6-1.2c0.2-0.4,0.5-0.8,0.7-1.2 c0.3-0.4,0.5-0.8,0.7-1.2c0.2-0.4,0.4-0.7,0.6-1c0.1-0.3,0.2-0.6,0.2-0.8c0-0.3-0.1-0.5-0.2-0.7s-0.3-0.3-0.6-0.3 c-0.3,0-0.6,0.1-0.9,0.3c-0.4,0.2-0.8,0.6-1.2,1c-0.4,0.4-0.9,1-1.5,1.6c-0.5,0.6-1.1,1.4-1.7,2.2c-0.4,0.5-0.7,0.9-1,1.4 c-0.1,0.2-0.3,0.4-0.4,0.6s-0.3,0.4-0.4,0.6s-0.3,0.4-0.4,0.6s-0.2,0.3-0.3,0.5l-1.1-0.5l1.5-2.1c0.2-0.3,0.4-0.6,0.7-0.9 c0.2-0.3,0.4-0.7,0.7-1c0.2-0.4,0.4-0.7,0.6-1.1c0.2-0.4,0.4-0.7,0.6-1c0.2-0.5,0.4-0.9,0.5-1.3c0.1-0.3,0.1-0.6,0.1-0.8 s0-0.4-0.1-0.5s-0.2-0.1-0.4-0.1c-0.2,0-0.3,0.1-0.6,0.2c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.3-0.4,0.6-0.7,0.9 c-0.2,0.3-0.4,0.7-0.6,1s-0.4,0.6-0.6,0.9c-0.2,0.3-0.3,0.5-0.4,0.7l-0.5-0.4c0.4-0.7,0.8-1.3,1.2-1.9c0.4-0.6,0.7-1.1,1-1.5 s0.6-0.7,1-1c0.3-0.2,0.6-0.3,1-0.3c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5 c0.1,0.2,0.1,0.5,0.1,0.7s0,0.5-0.1,0.7c0.4-0.4,0.7-0.7,1-0.9s0.6-0.4,0.9-0.6c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.4-0.1,0.6-0.1 s0.3,0,0.6,0.1c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.2,0.3,0.4,0.5,0.7C128.8,13.8,128.9,14.1,128.9,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M137,18.4c-0.3,0.4-0.7,0.7-1,1s-0.7,0.6-1,0.8s-0.7,0.4-1,0.5s-0.6,0.2-0.9,0.2c-0.3,0-0.6-0.1-0.9-0.2 c-0.3-0.1-0.5-0.3-0.7-0.5s-0.3-0.5-0.4-0.8c-0.1-0.3-0.2-0.7-0.2-1c0-0.5,0.1-1,0.3-1.6s0.5-1.1,0.8-1.6s0.7-1,1.1-1.5 c0.4-0.5,0.8-0.9,1.2-1.2l0.6,0.4c-0.1,0.1-0.2,0.3-0.4,0.6s-0.4,0.6-0.6,0.9c-0.2,0.3-0.4,0.7-0.6,1.1c-0.2,0.4-0.4,0.8-0.6,1.2 c-0.2,0.4-0.3,0.8-0.4,1.2c-0.1,0.4-0.2,0.8-0.2,1.2c0,0.2,0,0.3,0,0.5s0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,1-0.3c0.4-0.2,0.7-0.4,1.1-0.8c0.4-0.3,0.8-0.7,1.2-1.1s0.8-0.9,1.2-1.4s0.8-1,1.1-1.5 s0.7-1,1-1.5s0.5-0.9,0.8-1.4s0.5-0.9,0.8-1.3l0.6,0.3c0,0-0.1,0.2-0.2,0.5c-0.1,0.3-0.3,0.7-0.6,1.2c-0.2,0.5-0.5,1.1-0.9,1.8 c-0.3,0.7-0.7,1.4-1,2.2c-0.4,0.8-0.7,1.5-1.1,2.3c-0.4,0.8-0.7,1.6-1.1,2.3c1.2-0.7,2.3-1.5,3.3-2.4s1.8-1.9,2.5-2.9l0.5,0.4 c-0.7,1.1-1.7,2.2-2.8,3.1c-1.1,1-2.4,1.9-4,2.8c-0.7,1.5-1.4,2.9-2.1,4.2c-0.7,1.3-1.4,2.3-2,3.2c-0.7,0.9-1.4,1.6-2,2.1 c-0.7,0.5-1.4,0.7-2.1,0.7c-0.5,0-0.8-0.2-1.2-0.5s-0.5-0.7-0.5-1.3c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.5-1,0.9-1.5s0.8-1,1.3-1.5 s1.1-1,1.7-1.4c0.6-0.5,1.3-0.9,1.9-1.3c0.7-0.4,1.4-0.8,2-1.2c0.2-0.4,0.4-0.8,0.6-1.2c0.2-0.4,0.4-0.8,0.6-1.2 c0.2-0.4,0.4-0.8,0.6-1.1C136.7,18.9,136.9,18.6,137,18.4z M134.2,24c-1,0.6-1.9,1.3-2.7,1.9c-0.8,0.7-1.6,1.4-2.2,2 c-0.6,0.7-1.1,1.3-1.5,1.9c-0.3,0.6-0.5,1.1-0.5,1.5c0,0.3,0.1,0.5,0.2,0.7c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.7-0.1,1-0.3 c0.4-0.2,0.7-0.5,1.1-0.9c0.4-0.4,0.7-0.9,1.1-1.4c0.3-0.5,0.7-1.1,1-1.7s0.7-1.2,1-1.9C133.6,25.3,133.9,24.6,134.2,24z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M-5.3,51.6c0-4,2.1-6.5,5.1-6.5s5.1,2.5,5.1,6.5s-2.1,6.5-5.1,6.5S-5.3,55.7-5.3,51.6z M3.5,51.6 c0-3.5-1.5-5.3-3.7-5.3S-4,48.2-4,51.6c0,3.3,1.5,5.3,3.7,5.3S3.5,55.1,3.5,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M10.3,45.2v12.6H8.9V46.3H5.9v-1.2h4.4V45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M13.2,57.1c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.4,1.1-0.9,1.1C13.7,58.1,13.2,57.6,13.2,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M16.9,51.6c0-4,2.1-6.5,5.1-6.5s5.1,2.5,5.1,6.5s-2.1,6.5-5.1,6.5S16.9,55.7,16.9,51.6z M25.7,51.6 c0-3.5-1.5-5.3-3.7-5.3s-3.7,1.9-3.7,5.3c0,3.3,1.5,5.3,3.7,5.3C24.1,56.9,25.7,55.1,25.7,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M37.7,45.2v0.9L32.3,58H31l5.2-11.6h-6.5v2.4h-1.3v-3.6H37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M38.5,57.1c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9s-0.4,1.1-0.9,1.1C38.9,58.1,38.5,57.6,38.5,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M51.1,56.8V58h-8.9v-0.9l5.3-5.2c1.5-1.5,1.7-2.3,1.7-3.2c0-1.5-1.1-2.4-2.9-2.4c-1.5,0-2.7,0.4-3.5,1.5 L41.9,47c0.9-1.2,2.5-1.9,4.5-1.9c2.5,0,4.3,1.3,4.3,3.5c0,1.2-0.4,2.3-2.1,4l-4.3,4.3C44.3,56.8,51.1,56.8,51.1,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M52.7,51.6c0-4,2.1-6.5,5.1-6.5c2.9,0,5.1,2.4,5.1,6.5c0,4-2.1,6.5-5.1,6.5C54.8,58.1,52.7,55.7,52.7,51.6z  M61.5,51.6c0-3.5-1.5-5.3-3.7-5.3c-2.3,0-3.7,1.9-3.7,5.3c0,3.3,1.5,5.3,3.7,5.3C60,56.9,61.5,55.1,61.5,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M73.3,56.8V58h-8.9v-0.9l5.3-5.2c1.5-1.5,1.7-2.3,1.7-3.2c0-1.5-1.1-2.4-2.9-2.4c-1.5,0-2.7,0.4-3.5,1.5 L64.1,47c0.9-1.2,2.5-1.9,4.5-1.9c2.5,0,4.3,1.3,4.3,3.5c0,1.2-0.4,2.3-2.1,4l-4.3,4.3C66.5,56.8,73.3,56.8,73.3,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M83.4,54.3c0,2.1-1.6,3.7-4.7,3.7c-1.9,0-3.6-0.7-4.5-1.6l0.7-1.1c0.8,0.8,2.3,1.5,4,1.5 c2.1,0,3.3-0.9,3.3-2.5c0-1.5-1.1-2.5-3.5-2.5h-0.9v-0.9l3.5-4.4h-6.5v-1.2h8.1v0.9l-3.6,4.5C82.1,50.8,83.4,52.3,83.4,54.3z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1",
    className: "st79",
    x1: -6.9,
    y1: 37,
    x2: 147,
    y2: 37
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMobile);
export default __webpack_public_path__ + "static/media/header-mobile.7700f2419648d0dd4d72124334aeffb6.svg";
export { ForwardRef as ReactComponent };